import React, { useEffect, useRef, useState,useContext } from "react";
import { UserContext } from "../OEMChanges/OemAssetsImport";
import { connect } from "react-redux";
import {
  toggleModalAction,
  getRedeemHistoryAction,
  getCancleWithdrawAction,
  toggleAlertAction,
} from "../redux/actions/userAction";
import Loading from "../models/Loading";
import RedeemCancel from "../models/RedeemCancel";
import RGCancleAlert from "../models/RGCancleAlert";
import { ServerStatusCodes } from "../ServerStatusCodes";
import { REDEEM_HISTORY } from "../Strings";
import { WebToNativeMessage } from "../Common/Utils";
import navarrow from "../assets/back_btn.png";
import processed from "../assets/tick.svg";
import pending from "../assets/pendingRedeem.svg";
import remove2 from "../assets/Redeem-revamp/remove2.svg";
import { RUPEE_SYMBOL } from "../Strings";
// import viewPolicy from "../assets/Redeem-revamp/viewPolicy2.svg";
// import upArrow from "../assets/Redeem-revamp/upArrow.svg";
// import downArrow from "../assets/Redeem-revamp/downArrow.svg";
import axios from "../api/AxiosInstance";
// import "./redeemstyle.css";
import emptyredeem from "../assets/emptyRedeem.svg";
import redeemFailCrossicon from "../assets/Redeem-revamp/redeemfailCross.png";
import callUsIcon from "../assets/Redeem-revamp/callUsIcon.svg";
import Cross from "../assets/Redeem-revamp/Cross.svg";
import like from "../assets/Redeem-revamp/likeIcon.svg";
import dislike from "../assets/Redeem-revamp/dislikeIcon.svg";
import NewRequestIcon from "../assets/Redeem-revamp/NewRequestIcon.svg";
// import InfoIconBlue from '../assets/infoIconBlue.svg'

import { isTablet, isAndroid } from "react-device-detect";
import Tooltip from "../Tooltip";
const RedeemHistoryTwo = ({
  getRedeemHistoryAction,
  userState,
  toggleModalAction,
  toggleAlertAction,
  networkStatus,
  isCtaEnable,
  history,
}) => {
  const [state, setState] = useState({
    errors: {
      message: "",
    },
    tnx_refernce_id: "",
    amount: "",
    transactionId: "",
    description: "",
    type: "",
    selectedBank: {},
    createdAt: "",
    step: 0,
    withdraw_type: "",
    tnxhistoryData: [],
    token: window.sessionStorage["token"],
    channel: window.sessionStorage["channel"],
    isloading: true,
    isErrorMsgisShown: false,
    isViewRemoved: false,
  });
  const assets = useContext(UserContext);

  const [activeSection, setActiveSection] = useState(null);
  const [activeSectionCompleted, setActiveSectionCompleted] = useState(null);
  const [activeFeedback, setActiveFeedback] = useState(null);
  const [showMoreRequests, setShowMoreRequests] = useState(false);
  const [fetchDataCount, setFetchDataCount] = useState(0);
  const [redeemhistory, setRedeemHistory] = useState({});
  const [ongoingRequests, setOngoingRequests] = useState([]);
  const [completedRequests, setCompletedRequests] = useState([]);
  const [redeemIndex, setRedeemIndex] = useState(1);
  const [redeemDetails, setRedeemDetails] = useState({});
  const [isloading, setIsloading] = useState(true);
  const [feedbackM, setFeedback] = useState(false);
  const [msg, setMsg] = useState(false);

  const [feedbackResponse, setFeedbackResponse] = useState(false);
  const [badFeedbackResponse, setBadFeedbackResponse] = useState(false);
  const [submitFormBtn, setSubmitFormBtn] = useState(false);
  const [feedbackResponseData, setFeedbackResponseData] = useState(false);
  const [showPopup, setShowPopup] = useState(false);
  const [isSubmittedBtn, setIsSubmitted] = useState(true);
  // const [selectedOption, setSelectedOption] = useState('');
  const [selectedOptions, setSelectedOptions] = useState([]);
  const [textInput, setTextInput] = useState("");
  const [toastInvisible, setToastInvisible] = useState(false);
  const [toastMessageFeedback, setToastMessageFeedback] = useState(undefined);
  const [tnxID, setTnxID] = useState(undefined);
  const textAreaRef = useRef("");
  const [bottom, setBottom] = useState("25%");

  useEffect(() => {
    if (toastMessageFeedback !== undefined) {
      const timer = setTimeout(() => {
        setToastMessageFeedback(undefined);
      }, 4000);
      return () => clearTimeout(timer);
    }
  }, [toastMessageFeedback]);
  useEffect(() => {
      if (sessionStorage.getItem("channel") === "OEMAPS1") {
        //   import('./TransactionSummaryOEM.css');
        console.log("came into OEMAPS1")
        import('./redeemstyleOEM.css');
      } else {
        console.log("came into APS")
        import('./redeemstyle.css');
      }
    }, [])

  useEffect(() => {
    if (
      (textInput !== "" && selectedOptions.includes("Option4")) ||
      (selectedOptions.length > 0 && !selectedOptions.includes("Option4")) ||
      (selectedOptions.length > 1 && selectedOptions.includes("Option4"))
    ) {
      setSubmitFormBtn(true);
    } else {
      setSubmitFormBtn(false);
    }
  }, [textInput, selectedOptions]);
  const createToastMessage = () => {
    let toastMesage;
    toastMesage = (
      <div
        style={{
          position: "absolute",
          borderRadius: "0px",
          width: "100%",
          height: "8%",
          bottom: "0%",
          color: "#FFFFFF",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          fontSize: "0.8rem",
          fontWeight: "700",
          background: "green",
        }}
      >
        <div
          style={{
            width: "95%",
            height: "100%",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          {toastMessageFeedback}
          <span
            style={{ position: "absolute", right: "5%", fontSize: "1.2rem" }}
            onClick={() => setToastMessageFeedback(undefined)}
          >
            &times;
          </span>
        </div>
      </div>
    );
    return toastMesage;
  };


  const index = 0;
  const newSelectedOptionsGood = [
    ...selectedOptions.slice(0, index),
    "Good",
    ...selectedOptions.slice(index),
  ];
  const newSelectedOptionsBad = [
    "Bad",
    ...selectedOptions.slice(index),
    textInput,
  ];
  console.log(newSelectedOptionsBad, "newSelectedBad");

  const handleLikeClick = async (tID, amount, mode) => {
    WebToNativeMessage({
      type: "redeemCTEvent",
      eventName: "PF_c_clickRedeemFeedback_GoodBad",
      eventProperties: {
        Click_type: "Good",
        acelevel: window.sessionStorage["aceLevel"],
        channel: window.sessionStorage["channel"],
        subscription_type: window.sessionStorage["subscriptionType"],
        username: window.sessionStorage["screenName"],
        Redeem_Amount: amount,
        redeem_mode: mode,
      },
    });
    //  setFeedback(LikedMessageChange(tID, amount, mode));
    setFeedback(true);
    setFeedbackResponse(true);
    // setLoading(true)
    console.log("came here once");
    await axios({
      method: "POST",
      url: process.env.REACT_APP_NEW_BASE_URL + "redeem/user_feedback",
      headers: {
        Authorization: window.sessionStorage["token"],
      },
      data: {
        tnxId: tID,
        channel: window.sessionStorage["channel"],
        feedback: newSelectedOptionsGood,
        isGood: true,
      },
    })
      .then(async (res) => {
        console.log("came to feedback");
        if (res.data.error) {
          if (res.data.error.message) {
            setToastMessageFeedback(res.data.error.message);
          } else {
            setToastMessageFeedback("DB Error");
          }
        } else {
          setFeedbackResponseData(res.data.message);
          console.log(res.data.message, "msg");
          // setShow(true);
        }

        console.log(feedbackResponseData, "feedbackResponseData");
      })
      .catch((e) => {
        console.log("Like&Dislike");
      });
    //  setFetchDataCount(fetchDataCount + 1);
  };

  const handleDislikeClick = async (tID, amount, mode) => {
    WebToNativeMessage({
      type: "redeemCTEvent",
      eventName: "PF_c_clickRedeemFeedback_GoodBad",
      eventProperties: {
        Click_type: "Bad",
        acelevel: window.sessionStorage["aceLevel"],
        channel: window.sessionStorage["channel"],
        subscription_type: window.sessionStorage["subscriptionType"],
        username: window.sessionStorage["screenName"],
        Redeem_Amount: amount,
        redeem_mode: mode,
      },
    });
    setShowPopup(true);
    setTnxID(tID);
  };

  const handleCheckboxChange = (event) => {
    const { value, checked } = event.target;
    if (checked) {
      setSelectedOptions([...selectedOptions, value]);
    } else {
      setSelectedOptions(selectedOptions.filter((option) => option !== value));
    }
  };

  const handleCheckbox4Change = () => {
    setShowPopup(!showPopup);
  };

  const handleSubmit = async () => {
    console.log("Selected options:", selectedOptions);
    setShowPopup(false);
    setBadFeedbackResponse(true);
    // setTimeout(() => {
    //   setToastVisible(false);
    // }, 3000);
    setSelectedOptions([]);
    setTextInput("");
    setIsSubmitted(true);
    await axios({
      method: "POST",
      url: process.env.REACT_APP_NEW_BASE_URL + "redeem/user_feedback",
      headers: {
        Authorization: window.sessionStorage["token"],
      },
      data: {
        tnxId: tnxID,
        channel: window.sessionStorage["channel"],
        feedback: newSelectedOptionsBad,
        isGood: false,
      },
    })
      .then(async (res) => {
        console.log("came to feedback");
        if (res.data.error) {
          if (res.data.error.message) {
            setToastMessageFeedback(res.data.error.message);
          } else {
            setToastMessageFeedback("DB Error");
          }
        } else {
          await setFeedbackResponseData(res.data.message);
          setToastMessageFeedback(res.data.message);
          // setShow(true);
        }

        console.log(feedbackResponseData, "feedbackResponseData");
      })
      .catch((e) => {
        console.log("Like&Dislike");
      });
    await setFetchDataCount(fetchDataCount + 1);
  };

  const toggleSection = (index) => {
    setActiveSection((prevIndex) => (prevIndex === index ? null : index));
    setActiveSectionCompleted(null);
  };

  const toggleSectionCompleted = (index) => {
    setActiveSectionCompleted((prevIndex) => (prevIndex === index ? null : index));
    setActiveSection(null);
  };

  const feedbackToggle = (index) => {
    setActiveFeedback((prevIndex) => (prevIndex === index ? null : index));
  };


  const resetProps = () => {
    setRedeemIndex(1)
    setOngoingRequests([])
    setCompletedRequests([])
    // setShowMoreRequests(true)
  }

  const getMoreHistoryData = async () => {
    await axios({
      method: "POST",
      url: process.env.REACT_APP_NEW_BASE_URL + "redeem/redeem_history/",
      headers: {
        Authorization: window.sessionStorage["token"],
      },
      data: {
        index: redeemIndex !== undefined ? redeemIndex : 1,
      },
    })
      .then((res) => {

        const newOngoingData = res.data.ongoingRequest
        console.log(ongoingRequests, completedRequests, newOngoingData, "here1")
        // newOngoingData.length !== 0 && setOngoingRequests([...ongoingRequests,...newOngoingData])
        setOngoingRequests((prevDataOn) => ([...prevDataOn, ...newOngoingData]));

        const newCompletedData = res.data.completedRequest
        // newCompletedData.length !== 0 && setCompletedRequests([...completedRequests,...newCompletedData])

        setCompletedRequests((prevDataC) => ([...prevDataC, ...newCompletedData]));

        (newOngoingData.length === 0 && newCompletedData.length === 0) ? setShowMoreRequests(false) : setShowMoreRequests(true)
        console.log(newOngoingData, newCompletedData, "Vidya")
        setRedeemIndex(res.data.index)
        setRedeemHistory(res.data);

      })
      .catch((err) => {
        console.log(err);
      });
  }

  useEffect(() => {
    resetProps()
    async function fetchData() {
      setIsloading(true);
      axios
        .get(process.env.REACT_APP_NEW_BASE_URL + "redeem/redeem_details/", {
          headers: { Authorization: window.sessionStorage["token"] },
        })
        .then((response) => {
          setRedeemDetails(response.data);
          console.log(response.data);
        })
        .catch((e) => {
          console.log("error in getting redeem details", e);
        });

      await axios({
        method: "POST",
        url: process.env.REACT_APP_NEW_BASE_URL + "redeem/redeem_history/",
        headers: {
          Authorization: window.sessionStorage["token"],
        },
        data: {
          index: 1,
        },
      })
        .then((res) => {
          setRedeemHistory(res.data);
          setRedeemIndex(res.data.index)
          setOngoingRequests(res.data.ongoingRequest)
          setCompletedRequests(res.data.completedRequest)
          res.data.completedRequest.length === 0 ? setShowMoreRequests(false) : setShowMoreRequests(true)


        })
        .catch((err) => {
          console.log(err);
        });

      setIsloading(false);
    }
    fetchData();
  }, [fetchDataCount]);
  // console.log("Redeem History details success reducer ::::", ongoingRequests, completedRequests);
  // useEffect(() => {
  //   if (ongoingRequests ){
  //     toggleSection(0);
  //   }
  // }, []);
  //For Showing error Messages
  const showErrorMsg = async (statusCode, responseMsg) => {
    console.log("cancel Request status Codes:::", statusCode, responseMsg);
    if (statusCode === ServerStatusCodes.STATUSCODE_1205) {
      toggleAlertAction(true, REDEEM_HISTORY.STATUSCODE_1205);
    } else if (statusCode === ServerStatusCodes.STATUSCODE_1206) {
      toggleAlertAction(true, REDEEM_HISTORY.STATUSCODE_1206);
    } else if (statusCode === ServerStatusCodes.STATUSCODE_1207) {
      toggleAlertAction(true, REDEEM_HISTORY.STATUSCODE_1207);
    } else {
      toggleAlertAction(true, responseMsg);
    }
  };

  const updateRequestResponse = async (statusCode, msg) => {
    console.log("Cancel Request Message:", statusCode, msg);
    setState((prevState) => ({
      ...prevState,
      token: window.sessionStorage["token"],
      channel: window.sessionStorage["channel"],
      isErrorMsgisShown: false,
      isloading: true,
    }));
  };
  const handleCancleRequest = async (
    tnx_id,
    amount,
    redeemOption,
    transactionId,
    timestamp,
    cancelConfirmationInfoMsg,
    processingFeeAmount,
    transactionType,
    isSmartRedeem
  ) => {
    let userDetails = userState.profileData;
    const months = [
      "January",
      "February",
      "March",
      "April",
      "May",
      "June",
      "July",
      "August",
      "September",
      "October",
      "November",
      "December",
    ];
    const epoch = new Date(timestamp);
    const createdAtDate =
      epoch.getDay() +
      " " +
      months[epoch.getMonth()] +
      " " +
      epoch.getFullYear() +
      ", " +
      epoch.getHours() +
      ":" +
      epoch.getMinutes() +
      ":" +
      epoch.getSeconds();

    WebToNativeMessage({
      type: "redeemCTEvent",
      eventName: "pf_c_redeemcancelclick",
      eventProperties: {
        username: userDetails.screenName,
        channel: window.sessionStorage["channel"],
        aceLevel: userDetails.currentAceLevelName,
        redeemid: transactionId,
        redeemAmount: amount,
        processingFeeAmount : processingFeeAmount,
        timestamp: createdAtDate,
        Location: 'Redeem History Page',
        RedeemType: transactionType
      },
    });
    WebToNativeMessage({
      type: "mixpanelEvent",
      eventName: "pf_c_redeemcancelclick",
      eventProperties: {
        username: userDetails.screenName,
        channel: window.sessionStorage["channel"],
        aceLevel: userDetails.currentAceLevelName,
        redeemid: transactionId,
        redeemAmount: amount,
        processingFeeAmount : processingFeeAmount,
        timestamp: createdAtDate,
        Location: 'Redeem History Page',
        RedeemType: transactionType
      },
    })

    toggleModalAction(
      true,
      <RedeemCancel
        tnx_id={tnx_id}
        cancelConfirmationInfoMsg={cancelConfirmationInfoMsg}
        transactionId={transactionId}
        redeemableamount={amount}
        transactionType={transactionType}
        redeemOption={redeemOption}
        click_location='Redeem history page'
        updateRequestResponse={updateRequestResponse}
        history={history}
        redeemAmount={amount}
        handleRefresh={() => setFetchDataCount(fetchDataCount + 1)}
        isSmartRedeem={isSmartRedeem}
        location={"Redeem_History"}
      />,
      true
    );
  };
  // const currentTime = new Date().getTime();
  // const timestampTime = new Date(timestamp).getTime();
  // const sevenDaysAgo = currentTime - 7 * 24 * 60 * 60 * 1000;

  const getFormattedDate = (timeStamp) => {
    // return createdAtDate = epoch.getDay() + ' ' + months[epoch.getMonth()] + ' ' + epoch.getFullYear() + ', ' + epoch.getHours() + ':' + epoch.getMinutes() + ':' + epoch.getSeconds()
    // dd/mm/yyyy hh:mm am/pm
    var a = new Date(timeStamp);
    var months = [
      "Jan",
      "Feb",
      "Mar",
      "Apr",
      "May",
      "Jun",
      "Jul",
      "Aug",
      "Sep",
      "Oct",
      "Nov",
      "Dec",
    ];
    var year = a.getFullYear();
    // var month = months[a.getMonth()];
    var month = a.getMonth() + 1;
    var date = a.getDate();
    var hour = a.getHours();
    var min = a.getMinutes();
    var ampm = hour >= 12 ? "PM" : "AM";
    hour = hour % 12;
    hour = hour ? hour : 12; // the hour '0' should be '12'
    min = min < 10 ? "0" + min : min;
    var time =
      date + "/" + month + "/" + year + " " + hour + ":" + min + " " + ampm;
    return time;
  };

  const createFeedBackPopUp = () => {
    let feedbackpop = (
      <div
        style={{
          width: "100%",
          height: "100%",
          position: "absolute",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
        }}
      >
        <div
          style={{
            width: "100%",
            height: "100%",
            position: "absolute",
            background: "rgba(0,0,0,0.7)",
          }}
        ></div>
        <div
          style={{
            position: "absolute",
            ...(isTablet ? { width: "50%" } : { width: "95%" }),
            height: "50%",
            display: "flex",
            flexDirection: "column",
            background: "white",
            zIndex: "1",
            borderRadius: "6px 6px 0px 0px",
            bottom: bottom,
          }}
        >
          <div className="w-100" style={{ height: "100%" }}>
            <div
              style={{
                width: "100%",
                height: "12%",
                background: "#2C5391",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                borderRadius: "5px 5px 0px 0px",
              }}
            >
              <div
                style={{ fontWeight: 700, fontSize: "1rem", color: "#FFFFFF" }}
              >
                Share your Feedback
              </div>
              <img
                src={Cross}
                alt="close"
                style={{ position: "absolute", right: "5%" }}
                onClick={() => {
                  // handleSubmit();
                  setShowPopup(false);
                  WebToNativeMessage({
                    type: "redeemCTEvent",
                    eventName: "PF_c_Redeem_FeedbackSubmited",
                    eventProperties: {
                      acelevel: window.sessionStorage["aceLevel"],
                      channel: window.sessionStorage["channel"],
                      subscription_type: window.sessionStorage["subscriptionType"],
                      username: window.sessionStorage["screenName"],
                    },
                  });
                  setTextInput("");
                  setSelectedOptions([]);
                  // setToastInvisible(true);
                }}
              />
            </div>
            {/* <div className="feedbackheader" style={{width:'100%',height:"10%",background:'blue',display:"flex",alignItems:"center",justifyContent:"center",color:"#FFFFFF"}}>Share your Feedback</div> */}
            <div style={{ width: "100%", height: "88%", background: "white" }}>
              {/* Body */}
              <div
                className="flex flex-column mv1 w-100 items-center"
                style={{ height: "100%", fontSize: "0.9rem" }}
              >
                <div
                  className="w-90 tc pt1"
                  style={{ height: "15%", color: "#223655" }}
                >
                  {redeemDetails.feedbackPopupBody}
                </div>

                <div
                  style={{ height: "12%", alignItems: "center" }}
                  className={`${selectedOptions.includes("Option1")
                      ? "options-checked"
                      : "options"
                    }`}
                >
                  <label>{redeemDetails.feedbackPopupOptions[0]} </label>
                  <input
                    type="checkbox"
                    value="Option1"
                    checked={selectedOptions.includes("Option1")}
                    onChange={handleCheckboxChange}
                  />
                </div>
                {/* <br/> */}
                <div
                  style={{ height: "12%", alignItems: "center" }}
                  className={`${selectedOptions.includes("Option2")
                      ? "options-checked"
                      : "options"
                    }`}
                >
                  <label>{redeemDetails.feedbackPopupOptions[1]}</label>
                  <input
                    type="checkbox"
                    value="Option2"
                    checked={selectedOptions.includes("Option2")}
                    onChange={handleCheckboxChange}
                  />
                </div>
                {/* <br/> */}
                <div
                  style={{ height: "12%", alignItems: "center" }}
                  className={`${selectedOptions.includes("Option3")
                      ? "options-checked"
                      : "options"
                    }`}
                >
                  <label>{redeemDetails.feedbackPopupOptions[2]}</label>
                  <input
                    type="checkbox"
                    value="Option3"
                    checked={selectedOptions.includes("Option3")}
                    onChange={handleCheckboxChange}
                  />
                </div>
                {/* <br/> */}
                <div
                  className={`${selectedOptions.includes("Option4")
                      ? "other-options-parent-checked"
                      : "other-options-parent"
                    }`}
                >
                  <div
                    className={`${selectedOptions.includes("Option4")
                        ? "other-options mb3"
                        : "other-options"
                      }`}
                  >
                    <label>{redeemDetails.feedbackPopupOptions[3]}</label>
                    <input
                      type="checkbox"
                      value="Option4"
                      checked={selectedOptions.includes("Option4")}
                      onChange={handleCheckboxChange}
                    />
                  </div>
                  {showPopup && selectedOptions.includes("Option4") && (
                    <div className="w-100" style={{ height: "100%" }}>
                      <textarea
                        value={textInput}
                        style={{ height: "80%", outline: "1px solid #4A75BC" }}
                        ref={textAreaRef}
                        onFocus={() => isAndroid && setBottom("45%")}
                        onBlur={() => setBottom("25%")}
                        maxLength={200}
                        className="text-area-style w-100"
                        type="text"
                        placeholder={"Enter Comments (Upto 200 characters)"}
                        onChange={(e) => setTextInput(e.target.value)}
                      />
                    </div>
                  )}
                </div>
                <div
                  style={{ width: "100%", height: "15%", background: "white" }}
                >
                  {/* Footer */}
                  {!submitFormBtn ? (
                    <div className="flex items-center justify-center">
                      <div
                        className={`w-65 ba h2 center flex justify-center items-center pointer br2 tc f6 contoBold pa2 mv2 greyBtn white fw7`}
                      >
                        Submit
                      </div>
                    </div>
                  ) : (
                    <div className="flex items-center justify-center">
                      <div
                        className={`w-65 ba h2 fw7 center flex justify-center items-center darkGreenBorder pointer br2 tc f6 contoBold pa2 mv2 form-button white`}
                        onClick={() => {
                          handleSubmit();
                          WebToNativeMessage({
                            type: "redeemCTEvent",
                            eventName: "PF_c_Redeem_FeedbackSubmited",
                            eventProperties: {
                              acelevel: window.sessionStorage["aceLevel"],
                              channel: window.sessionStorage["channel"],
                              subscription_type: window.sessionStorage["subscriptionType"],
                              username: window.sessionStorage["screenName"],
                            },
                          });
                        }}
                      >
                        Submit
                      </div>
                    </div>
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );

    return feedbackpop;
  };

  const bankAccountEdited = (bankName) => {
    if (bankName === "HDFC Bank") {
      return "HDFC";
    } else if (
      bankName.toLowerCase() === "Kotak Mahindra Bank Ltd".toLowerCase()
    ) {
      return "Kotak";
    } else if (bankName.toLowerCase() === "ICICI Bank".toLowerCase()) {
      return "ICICI";
    } else if (bankName.toLowerCase() === "State Bank of India".toLowerCase()) {
      return "SBI";
    } else if (bankName.toLowerCase() === "Bank of Baroda".toLowerCase()) {
      return "BOB";
    } else if (bankName.toLowerCase() === "Bank of India".toLowerCase()) {
      return "BOI";
    } else if (
      bankName.toLowerCase() === "Punjab National Bank".toLowerCase()
    ) {
      return "PNB";
    } else if (
      bankName.toLowerCase() === "United Bank of India".toLowerCase()
    ) {
      return "UBI";
    } else if (
      bankName.toLowerCase() === "Central Bank of India".toLowerCase()
    ) {
      return "CBI";
    } else {
      return bankName.slice(0, 12) + "...";
    }
  };
  const onHistoryBackButtonCLick = () => {
    console.log(window.sessionStorage["reactLocation"], "reactLocation111")
    if (window.sessionStorage["reactLocation"] === "Redeem_History_Page") {
      WebToNativeMessage({ type: 'closeClient' });
      window.sessionStorage.removeItem("reactLocation");
    }
    else {
      history.goBack();
    }
  }

  return (
    <div
      className="redeemHistoryHeaderContainer"
    >
      <div
        id="History"
        className="redeemHistoryHeader"
      >
        <img id="historyBackButton"
          className="backBtn"
          src={assets?.assets?.navarrow}
          style={{ width: "40px", left: "2%" }}
          onClick={() => {
            onHistoryBackButtonCLick()
          }}
          alt="history"
        />
        History
        {!window.sessionStorage["reactLocation"] ? <div
          style={{
            height: "100%",
            top: "0",
            width: "35%",
            right: "5%",
            position: "absolute",
            display: "flex",
            justifyContent: "flex-end",
            alignItems: "center",
          }}
          id="new_request"
          onClick={() => {
            history.push("/redeem/");
            WebToNativeMessage({
              type: "redeemCTEvent",
              eventName:
                "PF_c_clickin_RedeemHistoryPage",
              eventProperties: {
                Button_clicked: "New Request",
                redeem_status:
                  'NA',
                acelevel:
                  window.sessionStorage["aceLevel"],
                channel:
                  window.sessionStorage["channel"],
                subscription_type:
                  window.sessionStorage[
                  "subscriptionType"
                  ],
                username:
                  window.sessionStorage[
                  "screenName"
                  ],
                Redeem_Amount: 'NA',
                redeem_mode: 'NA',
                Location: 'Redeem History Page',
                RedeemType: 'NA',
                isSmartRedeem:"No"
              },
            });
            WebToNativeMessage({
              type: "mixpanelEvent",
              eventName:
                "PF_c_clickin_RedeemHistoryPage",
              eventProperties: {
                Button_clicked: "New Request",
                redeem_status:
                  'NA',
                acelevel:
                  window.sessionStorage["aceLevel"],
                channel:
                  window.sessionStorage["channel"],
                subscription_type:
                  window.sessionStorage[
                  "subscriptionType"
                  ],
                username:
                  window.sessionStorage[
                  "screenName"
                  ],
                Redeem_Amount: 'NA',
                redeem_mode: 'NA',
                Location: 'Redeem History Page',
                RedeemType: 'NA',
                isSmartRedeem:"No"
              },
            });
          }}
        >
          <img
            src={assets?.assets?.NewRequestIcon}
            style={{ width: "12px", left: "2%" }}
            alt="history"
          />
          <span
          className="newRequestText"
            style={{
              fontSize: "13px",
              marginLeft: "5px",
              fontWeight: "600",
            }}
          >
            New Request
          </span>
        </div> : ""

        }
      </div>
      <div>
      {isloading && (
            <div
              style={{
                position: "absolute",
                width: "100%",
                height: "100%",
                background: "#ffffff",
                zIndex: "9",
                pointerEvents: "none",
                display:'flex',
                top:'0%',
                alignItems:'center',
                justifyContent:'center'
              }}
              onClick={(e) => {e.preventDefault()
                ;e.stopPropagation();
              }}
            >
              <Loading />
            </div>
          )}
        <div
          style={{
            height: "94%",
            display: "flex",
            flexDirection: "column",
            ...(isTablet
              ? { width: "50%", marginLeft: "25%" }
              : { width: "95%", marginLeft: "2.5%" }),
            position: "fixed",
            top: "6%",
            overflow: "scroll",
          }}
        >
          

          <div
            className=""
            style={{
              width: "95%",
              // height: "100%",
              maxHeight: "50px",
              marginTop: "3%",
              marginLeft: "2.5%",
              marginBottom: "3%",
            }}
            id="know_more"
            onClick={() => {
              window.sessionStorage.setItem("policyBack", "redeemhistory");
              WebToNativeMessage({
                type: "redeemCTEvent",
                eventName: "PF_c_RedeemPolicy_PageView",
                eventProperties: {
                  username: window.sessionStorage["screenName"],
                  channel: window.sessionStorage["channel"],
                  aceLevel: window.sessionStorage["aceLevel"],
                  subscription_type: window.sessionStorage["subscriptionType"],
                  click_location: "Redeem History",
                },
              });
              WebToNativeMessage({
                type: "mixpanelEvent",
                eventName: "PF_c_RedeemPolicy_PageView",
                eventProperties: {
                  username: window.sessionStorage["screenName"],
                  channel: window.sessionStorage["channel"],
                  aceLevel: window.sessionStorage["aceLevel"],
                  subscription_type: window.sessionStorage["subscriptionType"],
                  click_location: "Redeem History",
                },
              });
              // history.push("/redeeminfo/");
              WebToNativeMessage({ type: 'openRedeemPolicy' });
            }}
          >
            <div
              className="redeem-policy mid-grey flex"
              style={{ display: "flex", flexDirection: "row", height: "100%" }}
            >
              <div
                style={{
                  width: "10%",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                }}
              >
                <img style={{ width: "75%" }} src={assets?.assets?.viewPolicy} />
              </div>
              <div
                style={{
                  width: "88%",
                  marginLeft: "2%",
                  fontSize: "0.75rem",
                  height: "100%"

                }}
              >
                There have been recent changes to Withdraw Policy <br />
                <div
                  className="redeempolicyLink"
                  style={{ fontSize: "0.72rem", fontWeight: "700" }}
                >
                  Click here to know more
                </div>
              </div>
            </div>
          </div>

          {ongoingRequests &&
            ongoingRequests !== undefined &&
            ongoingRequests.length >= 0 &&
            ongoingRequests.filter(
              (x) =>
                x.type === "withdraw-processing" || x.type === "withdraw-request" || x.type === "RA"
            ).length > 0 ? (
            <div className="fw7 f8 primary-blue" style={{ marginLeft: "5%" }}>
              Ongoing Requests
            </div>
          ) : (
            <div>
              <div className="fw7 f8 primary-blue" style={{ marginLeft: "5%" }}>
                Ongoing Requests
              </div>
              <div className="flex items-center" style={{ margin: "5%" }}>
                <span className=" f7 tc mv2 black wrap w-100 mid-grey">
                  You don't have any ongoing request at the moment.
                </span>
              </div>
            </div>
          )}
          {
            <div>
              {ongoingRequests &&
                ongoingRequests !== undefined &&
                ongoingRequests.length > 0 &&
                ongoingRequests.map((x, index) => {
                  // const t = new Date(x.createdAt);
                  if (
                    x.type !== "withdraw-cancelled" &&
                    x.type !== "withdraw" &&
                    x.type !== "Withdraw-success"
                  ) {
                    return (
                      <div key={x._id}>
                        <div className="redeem-request">
                          <div>
                            <div
                              style={{
                                display: "flex",
                                justifyContent: "space-between",
                                marginTop: "0px",
                                alignItems: "center",
                              }}
                            >
                              {(x.type === "withdraw-request" ||
                                x.type !== "withdraw-cancelled" ||
                                (x.step !== 3 &&
                                  x.type !== "Withdraw-success") ||
                                x.type === "withdraw-processing" || x.type === "RA") && (
                                  <div className=" mv1 ">
                                    <span className="f6 contoBold mid-grey">
                                      Requested
                                    </span>
                                    <div
                                      className="f9 fw7 contoBold primary-blue"
                                      style={{
                                        marginTop: "8%",
                                      }}
                                    >
                                      {RUPEE_SYMBOL} {x.amount}
                                    </div>
                                  </div>
                                )}
                              {(x.step === 1 || x.step === 2) &&
                                (x.type === "withdraw-request" ||
                                  x.type === "withdraw-processing" || x.type === "RA") ? (
                                <div
                                  style={{
                                    color: "#CD7F32",
                                    fontSize: "12px",
                                    display: "flex",
                                    alignItems: "center",
                                    justifyContent: "space-between",
                                  }}
                                >
                                  {" "}
                                  <img
                                    style={{
                                      width: "1rem",
                                      paddingRight: "0.2rem",
                                    }}
                                    src={pending}
                                    alt="pending"
                                  />
                                  <span>
                                    Reviewing Withdrawal Request
                                  </span>
                                </div>
                              ) : ((x.step === 3) &&
                                (x.type === "withdraw-processing" || x.type === "RA")
                                ?
                                <div
                                  style={{
                                    color: "#CD7F32",
                                    fontSize: "12px",
                                    display: "flex",
                                    alignItems: "center",
                                    justifyContent: "space-between",
                                  }}
                                >
                                  {" "}
                                  <img
                                    style={{
                                      width: "1rem",
                                      paddingRight: "0.2rem",
                                    }}
                                    src={pending}
                                    alt="pending"
                                  />
                                  <span>
                                    Processing Withdrawal with your{" "}
                                    {x.withdrawType === "BANK"
                                      ? "bank"
                                      : x.withdrawType === "upi"
                                        ? "bank"
                                        : "wallet"}
                                  </span>
                                </div>
                                : ""

                              )}
                            </div>

                            <div
                              style={{
                                display: "flex",
                                justifyContent: "space-between",
                                width: "100%",
                                alignItems: "center",
                              }}
                            >
                              <div className={`f7 mv1 contoBold mid-grey ${(x.type === "withdraw-request" ||
                                x.type === "withdraw-processing" || x.type === "RA") &&
                                (x.step === 1 || x.step === 2) &&
                                !x.disableRedeemCancelFlag ? "w-70" : "w-100"}`}>
                                <div style={{ display: 'flex', flexDirection: 'column' }}>
                                  {/* {x?.isSmartRedeem && <span style={{ marginBottom: '5px' }}>Method : Smart Redeem</span>} */}
                                  {x?.isSmartRedeem && <span style={{ marginBottom: '5px' }}>Method : Wallet Booster</span>}
                                  <span>Requested on : {getFormattedDate(x.createdAt)}
                                  </span>
                                </div>
                              </div>
                              {/* <div
                              className="f7 contoBold mid-grey fw5"
                              style={{ marginTop: "0.5rem" }}
                            >
                              Usually takes 4 hours to credit amount
                            </div> */}

                              {(x.type === "withdraw-request" ||
                                x.type === "withdraw-processing" || x.type === "RA") &&
                                (x.step === 1 || x.step === 2) &&
                                !x.disableRedeemCancelFlag && (
                                  <div
                                    className="f7 tr br1"
                                    style={{ width: "30%" }}
                                  >
                                    <button
                                      id="cancel_redeem"
                                      className="cancelRedeemCTA"
                                      onClick={(e) => {
                                        {
                                          x.isPartiallyCancelled ? handleCancleRequest(
                                            x.redeemIdToSend,
                                            x.amountForFullCancellation,
                                            x.name,
                                            x.transactionId,
                                            x.createdAt,
                                            x.cancelConfirmationInfoMsg,
                                            x.processingFeeAmount,
                                            x.transactionType,
                                            x?.isSmartRedeem
                                          ) :
                                          handleCancleRequest(
                                            x._id,
                                            x.amountForFullCancellation,
                                            x.name,
                                            x.transactionId,
                                            x.createdAt,
                                            x.cancelConfirmationInfoMsg,
                                            x.processingFeeAmount,
                                            x.transactionType,
                                            x?.isSmartRedeem
                                          );
                                        }
                                        WebToNativeMessage({
                                          type: "redeemCTEvent",
                                          eventName:
                                            "PF_c_clickin_RedeemHistoryPage",
                                          eventProperties: {
                                            Button_clicked: "Cancel Withdraw",
                                            redeem_status:
                                              x.type ===
                                                "withdraw-request" ||
                                                x.type ===
                                                "withdraw-processing" || x.type === "RA"
                                                ? "Ongoing"
                                                : x.type ===
                                                  "withdraw-cancelled"
                                                  ? "Cancelled"
                                                  : (x.type ===
                                                    "Withdraw-success" || x.type === "withdraw")
                                                    && x.step === 4 ? "Completed" : "",
                                            acelevel:
                                              window.sessionStorage["aceLevel"],
                                            channel:
                                              window.sessionStorage["channel"],
                                            subscription_type:
                                              window.sessionStorage[
                                              "subscriptionType"
                                              ],
                                            username:
                                              window.sessionStorage[
                                              "screenName"
                                              ],
                                            Redeem_Amount: x.amount,
                                            redeem_mode: x.name,
                                            Location: 'Redeem History Page',
                                            RedeemType: x.transactionType,
                                            isSmartRedeem:x?.isSmartRedeem ? "Yes":"No",
                                          },
                                        });
                                        WebToNativeMessage({
                                          type: "mixpanelEvent",
                                          eventName:
                                            "PF_c_clickin_RedeemHistoryPage",
                                          eventProperties: {
                                            Button_clicked: "Cancel Withdraw",
                                            redeem_status:
                                              x.type ===
                                                "withdraw-request" ||
                                                x.type ===
                                                "withdraw-processing" || x.type === "RA"
                                                ? "Ongoing"
                                                : x.type ===
                                                  "withdraw-cancelled"
                                                  ? "Cancelled"
                                                  : (x.type ===
                                                    "Withdraw-success" || x.type === "withdraw")
                                                    && x.step === 4 ? "Completed" : "",
                                            acelevel:
                                              window.sessionStorage["aceLevel"],
                                            channel:
                                              window.sessionStorage["channel"],
                                            subscription_type:
                                              window.sessionStorage[
                                              "subscriptionType"
                                              ],
                                            username:
                                              window.sessionStorage[
                                              "screenName"
                                              ],
                                            Redeem_Amount: x.amount,
                                            redeem_mode: x.name,
                                            Location: 'Redeem History Page',
                                            RedeemType: x.transactionType,
                                            isSmartRedeem:x?.isSmartRedeem ? "Yes":"No",
                                          },
                                        });
                                      }}
                                    >
                                      {/* Cancel<br/>Redeem */}
                                      {REDEEM_HISTORY.REDEEM_HISTORY_CANCEL}
                                    </button>
                                  </div>
                                )}
                            </div>
                          </div>
                          {x.utr !== undefined && x.utr !== null && x.utr !== "" && <div className="flex f7 mid-grey">
                            UTR ID:{" "}
                            <div className="primary-blue fw6 pl1">
                              {x.utr}
                            </div>
                          </div>}
                          {/* <div style={{borderBottomStyle:"solid", borderBlockColor:"grey"}}/> */}
                          <div
                            key={index}
                            style={{
                              display: "flex",
                              alignItems: "center",
                              justifyContent: "center",
                              paddingTop: "2%",
                              marginTop: "2%",
                            }}
                            className={`accordion-section ${activeSection === index ? "" : ""
                              }`}
                          // onClick={() => toggleSection(index)}
                          >
                            {activeSection !== index ? (
                              <div
                                className="adn"
                                style={{
                                  display: "flex",
                                  alignItems: "center",
                                  justifyContent: "center",
                                }}
                                id="see_details"
                                onClick={() => {
                                  toggleSection(index);
                                  WebToNativeMessage({
                                    type: "redeemCTEvent",
                                    eventName: "PF_c_clickin_RedeemHistoryPage",
                                    eventProperties: {
                                      Button_clicked: "See Details",
                                      redeem_status:
                                        x.type ===
                                          "withdraw-request" ||
                                          x.type ===
                                          "withdraw-processing" || x.type === "RA"
                                          ? "Ongoing"
                                          : x.type ===
                                            "withdraw-cancelled"
                                            ? "Cancelled"
                                            : (x.type ===
                                              "Withdraw-success" || x.type === "withdraw")
                                              && x.step === 4 ? "Completed" : "",
                                      acelevel:
                                        window.sessionStorage["aceLevel"],
                                      channel: window.sessionStorage["channel"],
                                      subscription_type:
                                        window.sessionStorage[
                                        "subscriptionType"
                                        ],
                                      username:
                                        window.sessionStorage["screenName"],
                                      Redeem_Amount: x.amount,
                                      redeem_mode: x.name,
                                      Location: 'Redeem History Page',
                                      RedeemType: x.transactionType,
                                      isSmartRedeem:x?.isSmartRedeem ? "Yes":"No",
                                    },
                                  });
                                  WebToNativeMessage({
                                    type: "mixpanelEvent",
                                    eventName: "PF_c_clickin_RedeemHistoryPage",
                                    eventProperties: {
                                      Button_clicked: "See Details",
                                      redeem_status:
                                        x.type ===
                                          "withdraw-request" ||
                                          x.type ===
                                          "withdraw-processing" || x.type === "RA"
                                          ? "Ongoing"
                                          : x.type ===
                                            "withdraw-cancelled"
                                            ? "Cancelled"
                                            : (x.type ===
                                              "Withdraw-success" || x.type === "withdraw")
                                              && x.step === 4 ? "Completed" : "",
                                      acelevel:
                                        window.sessionStorage["aceLevel"],
                                      channel: window.sessionStorage["channel"],
                                      subscription_type:
                                        window.sessionStorage[
                                        "subscriptionType"
                                        ],
                                      username:
                                        window.sessionStorage["screenName"],
                                      Redeem_Amount: x.amount,
                                      redeem_mode: x.name,
                                      Location: 'Redeem History Page',
                                      RedeemType: x.transactionType,
                                      isSmartRedeem:x?.isSmartRedeem ? "Yes":"No",
                                    },
                                  });
                                }}
                              >
                                <span
                                  className="seeDetailsText"
                                  style={{ width: "88%", textAlign: "left" }}
                                >
                                  See Details
                                </span>
                                <img
                                  style={{ height: "100%", width: "12%" }}
                                  src={assets?.assets?.downArrow}
                                  alt="arrow"
                                />
                              </div>
                            ) : (
                              <div
                                style={{
                                  display: "flex",
                                  flexDirection: "column",
                                  overflowY: "none",
                                  width: "100%",
                                  overflowX: "none",
                                  alignItems: "center",
                                }}
                              >
                                <div
                                  className="adn"
                                  style={{
                                    // width: "25%",
                                    fontSize: "15px",
                                    display: "flex",
                                    alignItems: "center",
                                    justifyContent: "center",
                                  }}
                                  onClick={() => {
                                    toggleSection(index);
                                    WebToNativeMessage({
                                      type: "redeemCTEvent",
                                      eventName:
                                        "PF_c_clickin_RedeemHistoryPage",
                                      eventProperties: {
                                        Button_clicked: "Hide Details",
                                        redeem_status:
                                          x.type ===
                                            "withdraw-request" ||
                                            x.type ===
                                            "withdraw-processing" || x.type === "RA"
                                            ? "Ongoing"
                                            : x.type ===
                                              "withdraw-cancelled"
                                              ? "Cancelled"
                                              : (x.type ===
                                                "Withdraw-success" || x.type === "withdraw")
                                                && x.step === 4 ? "Completed" : "",
                                        acelevel:
                                          window.sessionStorage["aceLevel"],
                                        channel:
                                          window.sessionStorage["channel"],
                                        subscription_type:
                                          window.sessionStorage[
                                          "subscriptionType"
                                          ],
                                        username:
                                          window.sessionStorage["screenName"],
                                        Redeem_Amount: x.amount,
                                        redeem_mode: x.name,
                                        Location: 'Redeem History Page',
                                        RedeemType: x.transactionType,
                                        isSmartRedeem:x?.isSmartRedeem ? "Yes":"No",
                                      },
                                    });
                                    WebToNativeMessage({
                                      type: "mixpanelEvent",
                                      eventName:
                                        "PF_c_clickin_RedeemHistoryPage",
                                      eventProperties: {
                                        Button_clicked: "Hide Details",
                                        redeem_status:
                                          x.type ===
                                            "withdraw-request" ||
                                            x.type ===
                                            "withdraw-processing" || x.type === "RA"
                                            ? "Ongoing"
                                            : x.type ===
                                              "withdraw-cancelled"
                                              ? "Cancelled"
                                              : (x.type ===
                                                "Withdraw-success" || x.type === "withdraw")
                                                && x.step === 4 ? "Completed" : "",
                                        acelevel:
                                          window.sessionStorage["aceLevel"],
                                        channel:
                                          window.sessionStorage["channel"],
                                        subscription_type:
                                          window.sessionStorage[
                                          "subscriptionType"
                                          ],
                                        username:
                                          window.sessionStorage["screenName"],
                                        Redeem_Amount: x.amount,
                                        redeem_mode: x.name,
                                        Location: 'Redeem History Page',
                                        RedeemType: x.transactionType,
                                        isSmartRedeem:x?.isSmartRedeem ? "Yes":"No",
                                      },
                                    });
                                  }}
                                >
                                  <span
                                    className="seeDetailsText"
                                    style={{ width: "90%", textAlign: "left" }}
                                  >
                                    Hide Details
                                  </span>
                                  <img
                                    style={{
                                      height: "100%",
                                      width: "9%",
                                      marginLeft: "1%",
                                    }}
                                    src={assets?.assets?.upArrow}
                                    alt="arrow"
                                  />
                                </div>
                                <div
                                  className="dbData"
                                  style={{
                                    width: "100%",
                                    marginTop: "2%",
                                  }}
                                >
                                  {/* {x.transactionType === "instant" && !x.autoCheckStatus && <div className="mid-grey f7 mt2">Note - Unfortunately, this Instant Redeem will be considered as Standard due to additional checks.</div>} */}
                                  <div style={{ marginTop: "4%" }}>
                                    {/* method and utrid */}
                                    <div
                                      style={{
                                        display: "flex",
                                        flexDirection: "row",
                                        justifyContent: "space-between",
                                      }}
                                    >
                                      <span className="flex f6 mid-grey nowrap">
                                        {x.withdrawType === "upi"
                                          ? x.name
                                          : x.withdrawType === "BANK"
                                            ? "Bank"
                                            : "Wallet"}{" "}
                                        :
                                        <div className="f6 pl1 primary-blue fw6 ">
                                          {/* {console.log(bankAccountEdited(x.selectedBank.bankName),x.withdrawType)} */}
                                          <div>
                                            {x.withdrawType === "BANK"
                                              ? `${bankAccountEdited(
                                                x.selectedBank.bankName
                                              ) +
                                              "xxxxxx" +
                                              x.selectedBank.accountNumber.slice(
                                                x.selectedBank.accountNumber
                                                  .length - 4
                                              )
                                              }`
                                              : x.withdrawType === "upi"
                                                ? x.selectedBank.upi
                                                : `${x.withdrawType +
                                                " " +
                                                "xxxxxx" +
                                                x.selectedBank.accountNumber.slice(
                                                  6
                                                )
                                                }`}
                                          </div>
                                        </div>
                                      </span>
                                      {/* <div className=" flex f6 mid-grey">
                                        UTR ID:{" "}
                                        <div className="primary-blue fw6 pl1">
                                          {x.transactionId}
                                        </div>
                                      </div> */}
                                      <div className=" flex f6 mid-grey"> Type: <div className="fw6 primary-blue pl1"> {x.transactionType === "instant" ? "Instant" : x.transactionType === "standard" ? "Standard" : x.transactionType}</div></div>
                                    </div>
                                    {
                                      <div
                                        style={{
                                          display: "flex",
                                          flexDirection: "row",
                                          justifyContent: "space-between",
                                          marginTop: '1%',
                                          marginBottom:'1%'
                                        }}
                                      >
                                        <span className="flex f6 mid-grey nowrap">
                                          {"Withdraw ID"}{" "}
                                          :
                                          <div className="f6 pl1 primary-blue fw6 ">
                                            {/* {console.log(bankAccountEdited(x.selectedBank.bankName),x.withdrawType)} */}
                                            <div>
                                              {x.transactionId}
                                            </div>
                                          </div>
                                        </span>
                                        {/* <div className=" flex f6 mid-grey">
                                      UTR ID:{" "}
                                      <div className="primary-blue fw6 pl1">
                                        {x.transactionId}
                                      </div>
                                    </div> */}
                                        {(x.utr !== undefined && x.utr !== null && x.utr !== "") &&
                                          <div className=" flex f6 mid-grey"> UTR ID: <div className="fw6 primary-blue pl1"> {`Temp24556`}</div>

                                          </div>}
                                      </div>
                                    }

                                    {(x.type === "withdraw-request" ||
                                      x.type === "withdraw-processing" || x.type === "RA") && (
                                        <div
                                          // className="mt2"
                                          style={{
                                            marginTop: "5%",
                                            marginBottom: "5%",
                                          }}
                                          key={x.id}
                                        >
                                          <div
                                            style={{ alignItems: "center" }}
                                            className="workingStepRewards"
                                          >
                                            <div className="iconRewards">
                                              <img
                                                alt="step0Tag"
                                                style={{ width: "1rem" }}
                                                src={
                                                  x.step >= 1 ||
                                                    x.type === "withdraw-request"
                                                    ? processed
                                                    : redeemFailCrossicon
                                                }
                                              ></img>
                                            </div>
                                            <div className="workingText flexSpaceBetween">
                                              <span>Withdrawal Request Received</span>
                                              <span style={{color:'#707070'}}>{getFormattedDate(x.createdAt)}</span>
                                            </div>
                                          </div>
                                          {x.isPartiallyCancelled &&
                                            <>
                                              <div
                                                style={{ margin: "3px 0px 3px 0px" }}
                                                className="workingStepRewards"
                                              >
                                                <div className="iconRewards">
                                                  <div className="verticalline"></div>
                                                </div>
                                                <div className="workingText"></div>
                                              </div>
                                              <div className="workingStepRewards" style={{marginBottom:"5px"}}>
                                                <div className="iconRewards" >
                                                  <div className="flex flex-column items-center" >
                                                    <img
                                                      alt="step1Tag"
                                                      style={{ width: "1rem" }}
                                                      src={
                                                        // x.step > 2 &&
                                                        //   (x.type === "withdraw-processing" || x.type === "RA")
                                                        //   ? processed
                                                        //   : pending
                                                        processed
                                                      }
                                                    ></img>
                                                    <div
                                                      className={`${x.isPartiallyCancelled ? "verticallineExtended mb1" : "verticalline mv1"}`}
                                                      style={x.isPartiallyCancelled && {minHeight:"1.5rem",height:`${x?.partiallyCancelledArray?.length}rem`}}
                                                    ></div>
                                                  </div>
                                                </div>

                                                <div className="flex flex-column">
                                                  <div className="workingText">
                                                    <span>
                                                      Withdraw Partially Cancelled
                                                    </span>
                                                  </div>
                                                {x?.partiallyCancelledArray.map((item) => {
                                                  return (
                                                    <div className="workingText flexSpaceBetween">
                                                      <div style={{ color: "#BABABA",marginTop:"3px",fontSize:'0.65rem' }}>{RUPEE_SYMBOL}{item.amount} Partially Cancelled</div>
                                                      <span style={{color:'#BABABA',marginTop:"3px",fontSize:'0.65rem'}}>{getFormattedDate(item.createdAt)}</span>
                                                    </div>
                                                  )
                                                })}
                                                  
                                                </div>

                                              </div>
                                            </>}

                                          {!x.isPartiallyCancelled && <div
                                            style={{ margin: "3px 0px 3px 0px" }}
                                            className="workingStepRewards"
                                          >
                                            <div className="iconRewards">
                                              <div className="verticalline"></div>
                                            </div>
                                            <div className="workingText"></div>
                                          </div>}

                                          <div className="workingStepRewards">
                                            <div className="iconRewards">
                                              <div className="flex flex-column items-center">
                                                <img
                                                  alt="step1Tag"
                                                  style={{ width: "1rem" }}
                                                  src={
                                                    x.step > 2 &&
                                                      (x.type === "withdraw-processing" || x.type === "RA")
                                                      ? processed
                                                      : pending
                                                  }
                                                ></img>
                                                <div
                                                  className={`${(x.step === 2 || x.step === 1) && x.displayMessage !== "" ? "verticallineExtended mb2" : "verticalline mv1"}`}
                                                ></div>
                                              </div>
                                            </div>
                                            {
                                              x.displayMessage !== "" && (x.step === 2 || x.step === 1) ?
                                                <div className="flex flex-column">
                                                  <div className="workingText flexSpaceBetween">
                                                  <span>
                                                    Reviewing Withdrawal Request
                                                  </span>
                                                  {(x?.step2Timestamp && x.step2Timestamp!=='NA') &&<span style={{color:'#707070'}}>{getFormattedDate(x.step2Timestamp)}</span>}
                                                </div>
                                                  <div className="workingText">
                                                    <div className='colorRedOEM' style={{  marginTop: "1rem",marginBottom: "1rem"}}>{x.displayMessage}</div>
                                                  </div>
                                                </div>
                                                :
                                                <div className="workingText flexSpaceBetween">
                                                  <span>
                                                    Reviewing Withdrawal Request
                                                  </span>
                                                  {(x?.step2Timestamp && x.step2Timestamp!=='NA') &&<span style={{color:'#707070'}}>{getFormattedDate(x.step2Timestamp)}</span>}
                                                </div>
                                            }
                                          </div>

                                          {/* <div
                                          style={{ margin: "3px 3px 3px 0px" }}
                                          className="workingStepRewards"
                                        >
                                          <div className="iconRewards">
                                            <div
                                              // style={{ height: "18px" }}
                                              className="verticalline"
                                            ></div>
                                          </div>
                                          <div className="workingText"></div>
                                        </div> */}

                                          <div className="workingStepRewards">
                                            <div className="iconRewards">
                                              <div className="flex flex-column items-center">
                                                <img
                                                  alt="step2Tag"
                                                  style={{ width: "1rem" }}
                                                  src={
                                                    x.step < 3 &&
                                                      (x.type ===
                                                        "withdraw-processing" ||
                                                        x.type === "withdraw-request" || x.type === "RA")
                                                      ? emptyredeem
                                                      : x.step === 4
                                                        ? processed
                                                        : pending
                                                  }
                                                ></img>

                                                <div
                                                  className={`${x.step === 3 && x.displayMessage !== "" ? "verticallineExtended mb2" : "verticalline mv1"}`}
                                                ></div>
                                              </div>

                                            </div>
                                            {
                                              x.displayMessage !== "" && x.step === 3 ?
                                                <div className="flex flex-column">
                                                 
                                                  <div className="workingText flexSpaceBetween">
                                                    <span>
                                                      Processing withdrawal with your{" "}
                                                      {x.withdrawType === "BANK"
                                                        ? "bank"
                                                        : x.withdrawType === "upi"
                                                          ? "bank"
                                                          : "wallet"}
                                                    </span>
                                                    {(x?.step3Timestamp && x.step3Timestamp!=='NA') &&<span style={{color:'#707070'}}>{getFormattedDate(x.step3Timestamp)}</span>}

                                                  </div>
                                                  <div className="workingText">
                                                    <div className='colorRedOEM' style={{  marginTop: "1rem",marginBottom: "1rem"}} >{x.displayMessage}</div>
                                                  </div>

                                                </div>
                                                :
                                                <div className="workingText flexSpaceBetween">
                                                    <span>
                                                      Processing withdrawal with your{" "}
                                                      {x.withdrawType === "BANK"
                                                        ? "bank"
                                                        : x.withdrawType === "upi"
                                                          ? "bank"
                                                          : "wallet"}
                                                    </span>
                                                    {(x?.step3Timestamp && x.step3Timestamp!=='NA') &&<span style={{color:'#707070'}}>{getFormattedDate(x.step3Timestamp)}</span>}

                                                  </div>

                                            }
                                          </div>
                                          {/* {
                                          <div
                                          style={{ margin: "3px 3px 3px 0px" }}
                                          className="workingStepRewards"
                                        >
                                          <div className="iconRewards">
                                            <div
                                              className="verticalline"
                                            ></div>
                                          </div>
                                          <div className="workingText"></div>
                                        </div>} */}

                                          <div className="workingStepRewards">
                                            <div className="iconRewards">
                                              {/* <div className="flex flex-column"> */}
                                              <img
                                                style={{ width: "1rem" }}
                                                alt="step3Tag"
                                                src={
                                                  x.step < 4 &&
                                                    (x.type ===
                                                      "withdraw-processing" ||
                                                      x.type === "withdraw-request" || x.type === "RA")
                                                    ? emptyredeem
                                                    : pending
                                                }
                                              ></img>
                                              {/* <div
                                              // style={{ height: "18px" }}
                                              className={`${x.step === 3 && x.displayMessage !== "" ? "verticallineExtended" : "verticalline"}`}
                                            ></div> */}
                                              {/* </div> */}

                                            </div>
                                            <div className="workingText">
                                              <span>
                                                Amount credited to your{" "}
                                                {x.withdrawType === "BANK"
                                                  ? "bank account"
                                                  : x.withdrawType === "upi"
                                                    ? "bank account"
                                                    : "wallet"}
                                              </span>
                                              <div
                                                style={{
                                                  display: "flex",
                                                  alignItems: "flex-end",
                                                  justifyContent: "center",
                                                  float: "right",
                                                  color: "#2C5391",
                                                  fontSize: "0.7rem",
                                                  fontWeight: "700",
                                                  borderBottom:
                                                    "1px solid #2C5391",
                                                }}
                                                onClick={() => {
                                                  WebToNativeMessage({
                                                    type: "openContactUs",
                                                  });
                                                  WebToNativeMessage({
                                                    type: "redeemCTEvent",
                                                    eventName:
                                                      "PF_c_contactus_pageload",
                                                    eventProperties: {
                                                      click_location:
                                                        "Redeem History",
                                                    },
                                                  });

                                                  WebToNativeMessage({
                                                    type: "redeemCTEvent",
                                                    eventName:
                                                      "PF_c_clickin_RedeemHistoryPage",
                                                    eventProperties: {
                                                      Button_clicked:
                                                        "Need Help?",
                                                      redeem_status:
                                                        x.type ===
                                                          "withdraw-request" ||
                                                          x.type ===
                                                          "withdraw-processing" || x.type === "RA"
                                                          ? "Ongoing"
                                                          : x.type ===
                                                            "withdraw-cancelled"
                                                            ? "Cancelled"
                                                            : (x.type ===
                                                              "Withdraw-success" || x.type === "withdraw")
                                                              && x.step === 4 ? "Completed" : "",
                                                      acelevel:
                                                        window.sessionStorage[
                                                        "aceLevel"
                                                        ],
                                                      channel:
                                                        window.sessionStorage[
                                                        "channel"
                                                        ],
                                                      subscription_type:
                                                        window.sessionStorage[
                                                        "subscriptionType"
                                                        ],
                                                      username:
                                                        window.sessionStorage[
                                                        "screenName"
                                                        ],
                                                      Redeem_Amount: x.amount,
                                                      redeem_mode: x.name,
                                                      Location: 'Redeem History Page',
                                                      RedeemType: x.transactionType,
                                                      isSmartRedeem:x?.isSmartRedeem ? "Yes":"No",
                                                    },
                                                  });
                                                  WebToNativeMessage({
                                                    type: "mixpanelEvent",
                                                    eventName:
                                                      "PF_c_clickin_RedeemHistoryPage",
                                                    eventProperties: {
                                                      Button_clicked:
                                                        "Need Help?",
                                                      redeem_status:
                                                        x.type ===
                                                          "withdraw-request" ||
                                                          x.type ===
                                                          "withdraw-processing" || x.type === "RA"
                                                          ? "Ongoing"
                                                          : x.type ===
                                                            "withdraw-cancelled"
                                                            ? "Cancelled"
                                                            : (x.type ===
                                                              "Withdraw-success" || x.type === "withdraw")
                                                              && x.step === 4 ? "Completed" : "",
                                                      acelevel:
                                                        window.sessionStorage[
                                                        "aceLevel"
                                                        ],
                                                      channel:
                                                        window.sessionStorage[
                                                        "channel"
                                                        ],
                                                      subscription_type:
                                                        window.sessionStorage[
                                                        "subscriptionType"
                                                        ],
                                                      username:
                                                        window.sessionStorage[
                                                        "screenName"
                                                        ],
                                                      Redeem_Amount: x.amount,
                                                      redeem_mode: x.name,
                                                      Location: 'Redeem History Page',
                                                      RedeemType: x.transactionType,
                                                      isSmartRedeem:x?.isSmartRedeem ? "Yes":"No",
                                                    },
                                                  });
                                                  
                                                }}
                                              >
                                                {" "}
                                                Need help ?
                                              </div>
                                            </div>
                                          </div>
                                        </div>
                                      )}
                                  </div>
                                  <div className="flex items-center justify-center mh2 mv2">
                                    <div
                                      className="flex flex-column items-center br b--gray"
                                      style={{ flex: 1 }}
                                    >
                                      <div className="nowrap fw6 mid-grey f7 mb1">
                                        Withdraw
                                      </div>
                                      <div
                                        className="f9 fw7 nowrap primary-blue"
                                        style={{ fontWeight: "700" }}
                                      >
                                        {RUPEE_SYMBOL} {x.amount}
                                      </div>
                                    </div>
                                    {x.isPartiallyCancelled && <div
                                      className="flex flex-column items-center br b--gray"
                                      style={{ flex: 1 }}
                                    >
                                      <div className="nowrap fw6 mid-grey f7 mb1">
                                        Cancellation
                                      </div>
                                      <div
                                        className="f9 fw7 nowrap primary-blue"
                                        style={{ fontWeight: "700" }}
                                      >
                                        {RUPEE_SYMBOL} {x.totalPartialCancellationAmt}
                                      </div>
                                    </div>}
                                    {(x.transactionType==='Prime Instant' && x.processingFeeAmount>0) &&  <div
                                      className="flex flex-column items-center br b--gray"
                                      style={{ flex: 1 }}
                                    >
                                      <div className="nowrap fw6 mid-grey f7 mb1">
                                        Fees
                                          <Tooltip
                                            redeemProcessingFee={true}
                                            tooltipArrow="tooltip-arrow"
                                            direction={"bottom"}//processingFeePercent//redeemDetails?.paidInstantConfigData?.paidInstantProcessingFee
                                            content={`${x.processingFeePercent}% of Net withdrawable amount`}
                                          >
                                            <img src={assets?.assets?.InformationBlueIcon} style={{ width: "10px", marginLeft: "3px" }} />
                                          </Tooltip>
                                        
                                      </div>
                                      <div
                                        className="f9 fw7 nowrap primary-blue"
                                        style={{ fontWeight: "700" }}
                                      >
                                        {RUPEE_SYMBOL} {x.processingFeeAmount}
                                      </div>
                                    </div> }
                                    <div
                                      className="flex flex-column items-center br b--gray"
                                      style={{ flex: 1 }}
                                    >
                                      <div className="nowrap fw6 mid-grey f7 mb1">
                                        TDS
                                      </div>
                                      <div
                                        className="f9 fw7 nowrap primary-blue"
                                        style={{ fontWeight: "700" }}
                                      >
                                        {RUPEE_SYMBOL} {x.tdsDeducted}
                                      </div>
                                    </div>

                                    <div
                                      className="flex flex-column items-center"
                                      style={{ flex: 1 }}
                                    >
                                      <div
                                        className="tobecrediteddiv"
                                      >
                                        <div className=" nowrap fw6 ph1 mid-grey f7 mb1 mv1">
                                          To be credited
                                        </div>
                                        <div
                                          className="nowrap f9 fw7 primary-blue"
                                          style={{ fontWeight: "700" }}
                                        >
                                          {RUPEE_SYMBOL}{" "}
                                          {x.amountToBeCredited}
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                  {/* <FeedbackComponent /> */}
                                  { x.transactionType === "instant" && !x.autoCheckStatus && <div style={{width:"100%",background:'#f2f2f2',fontSize:"0.7rem",color:"#032146",padding:"8px 5px",boxSizing:"border-box",fontWeight:"600",borderRadius:"6px",marginTop:"10px"}}>Note - Unfortunately, this Instant withdrawal will be considered as Standard due to additional checks.</div>}
                                {/* {x.transactionType === 'Prime Instant' && x.cancelNoteMsg!=='' && <div style={{width:"100%",background:'#f2f2f2',fontSize:"0.7rem",color:"#032146",padding:"8px 5px",boxSizing:"border-box",fontWeight:"600",borderRadius:"6px",marginTop:"10px"}}>Note - {x.cancelNoteMsg}</div>} */}

                                </div>
                              </div>
                            )}
                          </div>
                        </div>
                      </div>
                    );
                  }
                })}
            </div>
          }
          {completedRequests &&
            completedRequests !== undefined &&
            completedRequests.length >= 0 && !(completedRequests.length === 0 && redeemhistory.newUser !== undefined && redeemhistory.newUser) &&
            completedRequests.filter((x) =>
              x.type.includes("withdraw-cancelled")
            ) && (
              <div style={{ marginLeft: "5%", marginBottom: "2%" }} className="fw7 f8 primary-blue">
                Completed Requests{" "}
              </div>
            )}
          <div>
            {completedRequests &&
              completedRequests !== undefined &&
              completedRequests.length > 0 &&
              completedRequests.map((x, index) => {
                // const t = new Date(x.createdAt);
                if (
                  x.type === "withdraw-cancelled" ||
                  x.type === "Withdraw-success" ||
                  x.type === "withdraw" ||
                  x.type === "withdraw-cancelled-partial" ||
                  x.step === "4"
                ) {
                  return (
                    <div key={x._id}>
                      <div className="redeem-request">
                        <div>
                          <div
                            style={{
                              display: "flex",
                              justifyContent: "space-between",
                              marginTop: "0px",
                              alignItems: "center",
                            }}
                          >
                            {" "}
                            {
                              <div className=" mv1">
                                <span className=" f6 contoBold mid-grey">
                                  Requested
                                </span>
                                <div
                                  className=" f9 fw7 contoBold primary-blue"
                                  style={{ marginTop: "8%" }}
                                >
                                  {RUPEE_SYMBOL} {x.amount}
                                </div>
                              </div>
                            }
                            {(x.type === "withdraw-cancelled" || x.type === 'withdraw-cancelled-partial') && !x.a23RejectedFlag && !x.bankRejectedFlag ? (
                              <div
                              className='colorRedOEM'
                                style={{
                                  fontSize: "12px",
                                  display: "flex",
                                  alignItems: "center",
                                  justifyContent: "space-between",
                                }}
                              >
                                <img
                                  src={assets?.assets?.remove2}
                                  style={{
                                    // height: "50%",
                                    width: "1rem",
                                    paddingRight: "0.2rem",
                                  }}
                                  alt="cancelled"
                                />
                                <span>{x.type === 'withdraw-cancelled-partial' ? "Partially Cancelled" : "Cancelled"}</span>
                              </div>
                            ) : x.a23RejectedFlag ?
                              (
                                <div
                                  className='colorRedOEM'
                                  style={{
                                    fontSize: "12px",
                                    display: "flex",
                                    alignItems: "center",
                                    justifyContent: "space-between",
                                  }}
                                >
                                  <img
                                    src={assets?.assets?.remove2}
                                    style={{
                                      // height: "50%",
                                      width: "1rem",
                                      paddingRight: "0.2rem",
                                    }}
                                    alt="cancelled"
                                  />
                                  <span>Rejected</span>
                                </div>
                              )
                              : x.bankRejectedFlag ?
                                (
                                  <div
                                    className='colorRedOEM'
                                    style={{
                                      fontSize: "12px",
                                      display: "flex",
                                      alignItems: "center",
                                      justifyContent: "space-between",
                                    }}
                                  >
                                    <img
                                      src={assets?.assets?.remove2}
                                      style={{
                                        // height: "50%",
                                        width: "1rem",
                                        paddingRight: "0.2rem",
                                      }}
                                      alt="cancelled"
                                    />
                                    <span>Rejected by your {x.withdrawType === "BANK"
                                      ? "bank"
                                      : x.withdrawType === "upi"
                                        ? "bank"
                                        : "wallet"}
                                    </span>
                                  </div>
                                )
                                : (x.type === "Withdraw-success" ||
                                  x.type === "withdraw") &&
                                  x.step === 4 ? (
                                  <div
                                    style={{
                                      color: "green",
                                      fontSize: "12px",
                                      display: "flex",
                                      alignItems: "center",
                                      justifyContent: "space-between",
                                    }}
                                  >
                                    <img
                                      src={processed}
                                      style={{
                                        // height: "50%",
                                        width: "1rem",
                                        paddingRight: "0.2rem",
                                      }}
                                      alt="completed"
                                    />
                                    <span>Amount Credited</span>
                                  </div>
                                ) : (
                                  ""
                                )}
                          </div>

                          <div className="f7 mv1 contoBold mid-grey">
                            <div style={{ display: 'flex', flexDirection: 'column' }}>
                              {/* {x?.isSmartRedeem && <span style={{ marginBottom: '5px' }}>Method : Smart Redeem</span>} */}
                              {x?.isSmartRedeem && <span style={{ marginBottom: '5px' }}>Method : Wallet Booster</span>}
                              <span>{x.type === 'withdraw-cancelled-partial' ? "Cancelled on :" :  "Requested on :"} {getFormattedDate(x.createdAt)}
                              </span>
                            </div>
                            
                          </div>
                          {(x.type === "Withdraw-success" ||
                            x.type === "withdraw") &&
                            x.step === 4 && (
                              <div
                                className="f7 contoBold mid-grey"
                                style={{ marginTop: "0.5rem" }}
                              >
                                
                                Credited on :{" "}
                                {getFormattedDate(x.epochTimeStamp)}
                              </div>
                            )}

                          {(x.type === "withdraw-cancelled") && (
                            <div
                              className="f7 contoBold mid-grey"
                              style={{ marginTop: "0.5rem" }}
                            >
                              {(x.bankRejectedFlag || x.a23RejectedFlag) ? "Completed on :" : "Cancelled on :"}
                              {getFormattedDate(x.epochTimeStamp)}
                            </div>
                          )}
                        </div>
                        {/* <div style={{borderBottomStyle:"solid", borderBlockColor:"grey"}}/> */}

                        <div
                          key={index}
                          style={{
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            paddingTop: "2%",
                            marginTop: "2%",
                          }}
                          className={`accordion-section ${activeSectionCompleted === index ? "" : ""
                            }`}
                        // onClick={() => toggleSection(index)}
                        >
                          {activeSectionCompleted !== index ? (
                            <div
                              className="adn"
                              id="see_details"
                              style={{
                                // width: "30%",
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "center",
                              }}
                              onClick={() => {
                                toggleSectionCompleted(index);
                                WebToNativeMessage({
                                  type: "redeemCTEvent",
                                  eventName: "PF_c_clickin_RedeemHistoryPage",
                                  eventProperties: {
                                    Button_clicked: "See Details",
                                    redeem_status:
                                      x.type ===
                                        "withdraw-request" ||
                                        x.type ===
                                        "withdraw-processing" || x.type === "RA"
                                        ? "Ongoing"
                                        : x.type ===
                                          "withdraw-cancelled"
                                          ? "Cancelled"
                                          : (x.type ===
                                            "Withdraw-success" || x.type === "withdraw")
                                            && x.step === 4 ? "Completed" : "",
                                    acelevel: window.sessionStorage["aceLevel"],
                                    channel: window.sessionStorage["channel"],
                                    subscription_type:
                                      window.sessionStorage["subscriptionType"],
                                    username:
                                      window.sessionStorage["screenName"],
                                    Redeem_Amount: x.amount,
                                    redeem_mode: x.name,
                                    Location: 'Redeem History Page',
                                    RedeemType: x.transactionType,
                                    isSmartRedeem:x?.isSmartRedeem ? "Yes":"No",
                                  },
                                });
                                WebToNativeMessage({
                                  type: "mixpanelEvent",
                                  eventName: "PF_c_clickin_RedeemHistoryPage",
                                  eventProperties: {
                                    Button_clicked: "See Details",
                                    redeem_status:
                                      x.type ===
                                        "withdraw-request" ||
                                        x.type ===
                                        "withdraw-processing" || x.type === "RA"
                                        ? "Ongoing"
                                        : x.type ===
                                          "withdraw-cancelled"
                                          ? "Cancelled"
                                          : (x.type ===
                                            "Withdraw-success" || x.type === "withdraw")
                                            && x.step === 4 ? "Completed" : "",
                                    acelevel: window.sessionStorage["aceLevel"],
                                    channel: window.sessionStorage["channel"],
                                    subscription_type:
                                      window.sessionStorage["subscriptionType"],
                                    username:
                                      window.sessionStorage["screenName"],
                                    Redeem_Amount: x.amount,
                                    redeem_mode: x.name,
                                    Location: 'Redeem History Page',
                                    RedeemType: x.transactionType,
                                    isSmartRedeem:x?.isSmartRedeem ? "Yes":"No",
                                  },
                                });
                              }}
                            >
                              <span
                                className="seeDetailsText"
                                style={{ width: "88%", textAlign: "left" }}
                              >
                                See Details
                              </span>
                              <img
                                style={{ height: "100%", width: "12%" }}
                                src={assets?.assets?.downArrow}
                                alt="arrow"
                              />
                            </div>
                          ) : (
                            <div
                              style={{
                                display: "flex",
                                flexDirection: "column",
                                overflowY: "none",
                                width: "100%",
                                overflowX: "none",
                                alignItems: "center",
                              }}
                            >
                              <div
                                className="adn"
                                style={{
                                  // width: "30%",
                                  fontSize: "15px",
                                  display: "flex",
                                  alignItems: "center",
                                  justifyContent: "center",
                                }}
                                onClick={() => {
                                  toggleSectionCompleted(index);
                                  WebToNativeMessage({
                                    type: "redeemCTEvent",
                                    eventName: "PF_c_clickin_RedeemHistoryPage",
                                    eventProperties: {
                                      Button_clicked: "Hide Details",
                                      redeem_status:
                                        x.type ===
                                          "withdraw-request" ||
                                          x.type ===
                                          "withdraw-processing" || x.type === "RA"
                                          ? "Ongoing"
                                          : x.type ===
                                            "withdraw-cancelled"
                                            ? "Cancelled"
                                            : (x.type ===
                                              "Withdraw-success" || x.type === "withdraw")
                                              && x.step === 4 ? "Completed" : "",
                                      acelevel:
                                        window.sessionStorage["aceLevel"],
                                      channel: window.sessionStorage["channel"],
                                      subscription_type:
                                        window.sessionStorage[
                                        "subscriptionType"
                                        ],
                                      username:
                                        window.sessionStorage["screenName"],
                                      Redeem_Amount: x.amount,
                                      redeem_mode: x.name,
                                      Location: 'Redeem History Page',
                                      RedeemType: x.transactionType,
                                      isSmartRedeem:x?.isSmartRedeem ? "Yes":"No",
                                    },
                                  });
                                  WebToNativeMessage({
                                    type: "mixpanelEvent",
                                    eventName: "PF_c_clickin_RedeemHistoryPage",
                                    eventProperties: {
                                      Button_clicked: "Hide Details",
                                      redeem_status:
                                        x.type ===
                                          "withdraw-request" ||
                                          x.type ===
                                          "withdraw-processing" || x.type === "RA"
                                          ? "Ongoing"
                                          : x.type ===
                                            "withdraw-cancelled"
                                            ? "Cancelled"
                                            : (x.type ===
                                              "Withdraw-success" || x.type === "withdraw")
                                              && x.step === 4 ? "Completed" : "",
                                      acelevel:
                                        window.sessionStorage["aceLevel"],
                                      channel: window.sessionStorage["channel"],
                                      subscription_type:
                                        window.sessionStorage[
                                        "subscriptionType"
                                        ],
                                      username:
                                        window.sessionStorage["screenName"],
                                      Redeem_Amount: x.amount,
                                      redeem_mode: x.name,
                                      Location: 'Redeem History Page',
                                      RedeemType: x.transactionType,
                                      isSmartRedeem:x?.isSmartRedeem ? "Yes":"No",
                                    },
                                  });
                                }}
                              >
                                <span
                                  className="seeDetailsText"
                                  style={{ width: "90%", textAlign: "left" }}
                                >
                                  Hide Details
                                </span>
                                <img
                                  style={{
                                    height: "100%",
                                    width: "9%",
                                    marginLeft: "1%",
                                  }}
                                  src={assets?.assets?.upArrow}
                                  alt="arrow"
                                />
                              </div>
                              <div
                                className="dbData"
                                style={{
                                  width: "100%",
                                  marginTop: "2%", 
                                }}
                              >
                                {/* color:'#032146' */}
                                {/* {x.transactionType === "instant" && !x.autoCheckStatus && <div className="mid-grey f7 mt2">Note - Unfortunately, this Instant Redeem will be considered as Standard due to additional checks.</div>} */}
                                {x.type === "withdraw-cancelled-partial" && <div className="mid-grey f7 mt2" style={{fontWeight:'700'}}>Cancelled from Withdraw ID : <span className="primary-blue">{x.parentId}</span>  </div>}
                                {(((x.type === "withdraw-cancelled") && x.displayMessage === "") || (x.type === "withdraw" || x.type === "Withdraw-success")) &&
                                  <div style={{ marginTop: "4%" }}>
                                    {/* method and utr id */}
                                    <div
                                      style={{
                                        display: "flex",
                                        // flexDirection: "row",
                                        flexDirection: "column",
                                        // justifyContent: "space-between",
                                      }}
                                    >
                                      {console.log(x.withdrawType, "")}
                                      <div className="flex row justify-between">
                                        <span className="flex f6 mid-grey nowrap mb2">
                                          {x.withdrawType === "upi"
                                            ? x.name
                                            : x.withdrawType === "BANK"
                                              ? "Bank"
                                              : "Wallet"}{" "}
                                          :
                                          <div className="pl1 f6 fw6 primary-blue">
                                            <div>
                                              {x.withdrawType === "BANK"
                                                ? `${bankAccountEdited(
                                                  x.selectedBank.bankName
                                                ) +
                                                "xxxxxx" +
                                                x.selectedBank.accountNumber.slice(
                                                  x.selectedBank.accountNumber
                                                    .length - 4
                                                )
                                                }`
                                                : x.withdrawType === "upi"
                                                  ? x.selectedBank.upi
                                                  : `${x.withdrawType +
                                                  " " +
                                                  "xxxxxx" +
                                                  x.selectedBank.accountNumber.slice(
                                                    6
                                                  )
                                                  }`}
                                            </div>
                                          </div>
                                        </span>
                                        <div className=" flex f6 mid-grey"> Type: <div className="fw6 primary-blue pl1"> {x.transactionType === "instant" ? "Instant" : x.transactionType === "standard" ? "Standard" : x.transactionType}</div></div>
                                        
                                      </div>
                                      <div
                                        style={{
                                          display: "flex",
                                          flexDirection: "row",
                                          justifyContent: "space-between",
                                          marginTop: '1%',
                                          marginBottom:'1%'
                                        }}
                                      >
                                        <span className="flex f6 mid-grey nowrap">
                                          {"Withdraw ID"}{" "}
                                          :
                                          <div className="f6 pl1 primary-blue fw6 ">
                                            {/* {console.log(bankAccountEdited(x.selectedBank.bankName),x.withdrawType)} */}
                                            <div>
                                              {x.transactionId}
                                            </div>
                                          </div>
                                        </span>
                                        {/* <div className=" flex f6 mid-grey">
                                      UTR ID:{" "}
                                      <div className="primary-blue fw6 pl1">
                                        {x.transactionId}
                                      </div>
                                    </div> */}
                                        {!(x.type === "withdraw-cancelled" && x.a23RejectedFlag) && !(x.type === "withdraw-cancelled" && !x.a23RejectedFlag && !x.bankRejectedFlag) && x.utr !== undefined && x.utr !== null && x.utr !== "" &&
                                          <div className=" flex f6 mid-grey">
                                            UTR ID:{" "}
                                            <div className="primary-blue fw6 pl1">
                                              {x.utr}
                                            </div>
                                          </div>
                                          }
                                      </div>
                                      
                                      
                                      
                                    </div>
                                  </div>}

                                {x.type === "withdraw-cancelled" && !x.a23RejectedFlag && !x.bankRejectedFlag && (
                                  <div className=" mt2" key={x.id}>
                                    <div
                                      style={{ alignItems: "center" }}
                                      className="workingStepRewards"
                                    >
                                      <div className="iconRewards">
                                        <img
                                          alt="step0Tag"
                                          style={{ width: "1rem" }}
                                          src={processed}
                                        ></img>
                                      </div>
                                      <div className="workingText flexSpaceBetween" >
                                        <span>Withdrawal Request Received</span>
                                        <span style={{color:'#707070'}}>{getFormattedDate(x.createdAt)}</span>
                                      </div>
                                    </div>
                                  </div>
                                )}

                                {(x.type === "withdraw-cancelled" && x?.isPartiallyCancelled!==true) && !x.a23RejectedFlag && !x.bankRejectedFlag && (
                                  <div
                                    style={{ margin: "3px 0px 3px 0px" }}
                                    className="workingStepRewards"
                                  >
                                    <div className="iconRewards">
                                      <div className="verticalline"></div>
                                    </div>
                                    <div className="workingText"></div>
                                  </div>
                                  
                                )}
                                  {(x.type === 'withdraw-cancelled' && x?.isPartiallyCancelled && !x.a23RejectedFlag && !x.bankRejectedFlag) &&
                                            <>
                                              <div
                                                style={{ margin: "3px 0px 3px 0px" }}
                                                className="workingStepRewards"
                                              >
                                                <div className="iconRewards">
                                                  <div className="verticalline"></div>
                                                </div>
                                                <div className="workingText"></div>
                                              </div>
                                              <div className="workingStepRewards" style={{marginBottom:"5px"}}>
                                                <div className="iconRewards">
                                                  <div className="flex flex-column items-center" >
                                                    <img
                                                      alt="step1Tag"
                                                      style={{ width: "1rem" }}
                                                      src={
                                                        // x.step > 2 &&
                                                        //   (x.type === "withdraw-processing" || x.type === "RA")
                                                        //   ? processed
                                                        //   : pending
                                                        processed
                                                      }
                                                    ></img>
                                                    <div
                                                      className={`${x.isPartiallyCancelled ? "verticallineExtended mb1" : "verticalline mv1"}`}
                                                      style={x.isPartiallyCancelled && {minHeight:'1.5rem',height:`${x?.partiallyCancelledArray?.length}rem`}}
                                                    ></div>
                                                  </div>
                                                </div>

                                                <div className="flex flex-column">
                                                  <div className="workingText">
                                                    <span>
                                                      Withdraw Partially Cancelled
                                                    </span>
                                                  </div>
                                                {x?.partiallyCancelledArray.map((item) => {
                                                  return (
                                                    <div className="workingText flexSpaceBetween">
                                                      <div style={{ color: "#BABABA",marginTop:"3px",fontSize:'0.65rem' }}>{RUPEE_SYMBOL}{item.amount} Partially Cancelled</div>
                                                      <span style={{color:'#BABABA',marginTop:"3px",fontSize:'0.65rem'}}>{getFormattedDate(item.createdAt)}</span>
                                                    </div>
                                                  )
                                                })}
                                                  
                                                </div>

                                              </div>
                                            </>}
                                

                                {x.type === "withdraw-cancelled" && !x.a23RejectedFlag && !x.bankRejectedFlag ?
                                  (
                                    <div className="mt1" key={x.id}>
                                      <div
                                        style={{ alignItems: "center" }}
                                        className="workingStepRewards"
                                      >
                                        <div className="iconRewards">
                                          <img
                                            alt="step0Tag"
                                            style={{ width: "1rem" }}
                                            src={processed}
                                          ></img>
                                        </div>
                                        <div className="workingText flexSpaceBetween">
                                          <span>Withdrawal Cancelled</span>
                                          <span style={{color:'#707070'}}>{getFormattedDate(x.epochTimeStamp)}</span>
                                        </div>
                                      </div>
                                    </div>
                                  )
                                  :
                                  (x.type !== "withdraw" && x.type !== "Withdraw-success" && <div
                                    className="db"
                                    style={{
                                      width: "100%",
                                      // marginTop: "2%",
                                      // borderTop: "1px solid #bababa",
                                    }}
                                  >
                                    <div style={{ marginTop: "4%" }}>
                                      {/* method and utr id */}
                                      <div
                                        style={{
                                          display: "flex",
                                          flexDirection: "row",
                                          // flexDirection: "column",
                                          justifyContent: "space-between",
                                        }}
                                      >
                                        <span className="flex f6 mid-grey nowrap mb2">
                                          {x.withdrawType === "upi"
                                            ? x.name
                                            : x.withdrawType === "BANK"
                                              ? "Bank"
                                              : "Wallet"}{" "}
                                          :
                                          <div className="f6 pl1 primary-blue fw6 ">
                                            {/* {console.log(bankAccountEdited(x.selectedBank.bankName),x.withdrawType)} */}
                                            <div>
                                              {x.withdrawType === "BANK"
                                                ? `${bankAccountEdited(
                                                  x.selectedBank.bankName
                                                ) +
                                                "xxxxxx" +
                                                x.selectedBank.accountNumber.slice(
                                                  x.selectedBank.accountNumber
                                                    .length - 4
                                                )
                                                }`
                                                : x.withdrawType === "upi"
                                                  ? x.selectedBank.upi
                                                  : `${x.withdrawType +
                                                  " " +
                                                  "xxxxxx" +
                                                  x.selectedBank.accountNumber.slice(
                                                    6
                                                  )
                                                  }`}
                                            </div>
                                          </div>
                                        </span>
                                        <div className=" flex f6 mid-grey"> Type: <div className="fw6 primary-blue pl1"> {x.transactionType === "instant" ? "Instant" : x.transactionType === "standard" ? "Standard" : x.transactionType}</div></div>
                                        
                                        
                                        

                                        </div>
                                        {
                                      <div
                                        style={{
                                          display: "flex",
                                          flexDirection: "row",
                                          justifyContent: "space-between",
                                          marginTop: '1%',
                                          marginBottom:'1%'
                                        }}
                                      >
                                        <span className="flex f6 mid-grey nowrap">
                                          {"Withdraw ID"}{" "}
                                          :
                                          <div className="f6 pl1 primary-blue fw6 ">
                                            {/* {console.log(bankAccountEdited(x.selectedBank.bankName),x.withdrawType)} */}
                                            <div>
                                              {x.transactionId}
                                            </div>
                                          </div>
                                        </span>
                                        {/* <div className=" flex f6 mid-grey">
                                      UTR ID:{" "}
                                      <div className="primary-blue fw6 pl1">
                                        {x.transactionId}
                                      </div>
                                    </div> */}
                                        {!(x.type === "withdraw-cancelled" && x.a23RejectedFlag) && !(x.type === "withdraw-cancelled" && !x.a23RejectedFlag && !x.bankRejectedFlag) && x.utr !== undefined && x.utr !== null && x.utr !== "" &&
                                          <div className=" flex f6 mid-grey">
                                            UTR ID:{" "}
                                            <div className="primary-blue fw6 pl1">
                                              {x.utr}
                                            </div>
                                          </div>
                                          }
                                      </div>
                                    }
                                        

                                        {(x.type === "withdraw-cancelled") && (x.type !== "withdraw" && x.type !== "Withdraw-success") && (
                                        <div
                                          // className="mt2"
                                          style={{
                                            marginTop: "5%",
                                            marginBottom: "5%",
                                          }}
                                          key={x.id}
                                        >
                                          <div
                                            style={{ alignItems: "center" }}
                                            className="workingStepRewards"
                                          >
                                            <div className="iconRewards">
                                              <img
                                                alt="step0Tag"
                                                style={{ width: "1rem" }}
                                                src={
                                                  x.step >= 1 ||
                                                    x.type === "withdraw-request"
                                                    ? processed
                                                    : redeemFailCrossicon
                                                }
                                              ></img>
                                            </div>
                                            <div className="workingText flexSpaceBetween">
                                              <span>Withdrawal Request Received</span>
                                              <span style={{color:'#707070'}}>{getFormattedDate(x.createdAt)}</span>
                                            </div>
                                          </div>

                                          {x?.isPartiallyCancelled!==true &&<div
                                            style={{ margin: "3px 0px 3px 0px" }}
                                            className="workingStepRewards"
                                          >
                                            <div className="iconRewards">
                                              <div className="verticalline"></div>
                                            </div>
                                            <div className="workingText"></div>
                                          </div>}
                                          {(x.type === 'withdraw-cancelled' && x?.isPartiallyCancelled) &&
                                            <>
                                              <div
                                                style={{ margin: "3px 0px 3px 0px" }}
                                                className="workingStepRewards"
                                              >
                                                <div className="iconRewards">
                                                  <div className="verticalline"></div>
                                                </div>
                                                <div className="workingText"></div>
                                              </div>
                                              <div className="workingStepRewards" style={{marginBottom:"5px"}}>
                                                <div className="iconRewards">
                                                  <div className="flex flex-column items-center" >
                                                    <img
                                                      alt="step1Tag"
                                                      style={{ width: "1rem" }}
                                                      src={
                                                        // x.step > 2 &&
                                                        //   (x.type === "withdraw-processing" || x.type === "RA")
                                                        //   ? processed
                                                        //   : pending
                                                        processed
                                                      }
                                                    ></img>
                                                    <div
                                                      className={`${x.isPartiallyCancelled ? "verticallineExtended mb1" : "verticalline mv1"}`}
                                                      style={x.isPartiallyCancelled && {minHeight:'1.5rem',height:`${x?.partiallyCancelledArray?.length}rem`}}
                                                    ></div>
                                                  </div>
                                                </div>

                                                <div className="flex flex-column">
                                                  <div className="workingText">
                                                    <span>
                                                      Withdraw Partially Cancelled
                                                    </span>
                                                  </div>
                                                {x?.partiallyCancelledArray.map((item) => {
                                                  return (
                                                    <div className="workingText flexSpaceBetween">
                                                      <div style={{ color: "#BABABA",marginTop:"3px",fontSize:'0.65rem' }}>{RUPEE_SYMBOL}{item.amount} Partially Cancelled</div>
                                                      <span style={{color:'#BABABA',marginTop:"3px",fontSize:'0.65rem'}}>{getFormattedDate(item.createdAt)}</span>
                                                    </div>
                                                  )
                                                })}
                                                  
                                                </div>

                                              </div>
                                            </>}

                                          <div className="workingStepRewards">
                                            <div className="flex flex-column iconRewards">

                                              <img
                                                alt="step1Tag"
                                                style={{ width: "1rem" }}
                                                src={
                                                  x.a23RejectedFlag ? assets?.assets?.remove2 : processed
                                                }
                                              ></img>
                                              <div className={`${x.a23RejectedFlag ? "verticallineExtended" : "verticalline mt1"}`} />
                                            </div>
                                            {x.a23RejectedFlag ?
                                              <div className="flex flex-column">
                                                <div className="workingText flexSpaceBetween">
                                                  <span>
                                                    Reviewing Withdrawal Request
                                                  </span>
                                                  {(x?.step2Timestamp && x.step2Timestamp!=='NA') &&<span style={{color:'#707070'}}>{getFormattedDate(x.step2Timestamp)}</span>}
                                                </div>
                                                <div className='colorRedOEM' style={{  marginTop: "1rem",marginBottom: "1rem"}}>
                                                  {x.displayMessage}
                                                </div>
                                              </div>

                                              :
                                              <div className="workingText flexSpaceBetween">
                                                  <span>
                                                    Reviewing Withdrawal Request
                                                  </span>
                                                  {(x?.step2Timestamp && x.step2Timestamp!=='NA') &&<span style={{color:'#707070'}}>{getFormattedDate(x.step2Timestamp)}</span>}
                                                </div>
                                            }
                                          </div>

                                          <div
                                            style={{ margin: "3px 3px 3px 0px" }}
                                            className="workingStepRewards"
                                          >
                                            {/* <div className="iconRewards">
                                          <div
                                            // style={{ height: "18px" }}
                                            className="verticalline"
                                          ></div>
                                        </div> */}
                                            <div className="workingText"></div>
                                          </div>

                                          <div className="workingStepRewards">
                                            <div className="">

                                              <div className="flex flex-column iconRewards">
                                                <img
                                                  alt="step2Tag"
                                                  style={{ width: "1rem" }}
                                                  src={
                                                    x.bankRejectedFlag ? assets?.assets?.remove2 : emptyredeem
                                                  }
                                                ></img>


                                                <div className={`${x.bankRejectedFlag ? "verticallineExtended" : "verticalline mt1"}`} />
                                              </div>
                                            </div>
                                            {
                                              x.bankRejectedFlag ?
                                                <div className="flex flex-column">
                                                  <div className="workingText flexSpaceBetween">
                                                    <span>
                                                      Processing withdrawal with your{" "}
                                                      {x.withdrawType === "BANK"
                                                        ? "bank"
                                                        : x.withdrawType === "upi"
                                                          ? "bank"
                                                          : "wallet"}
                                                    </span>
                                                    {(x?.step3Timestamp && x.step3Timestamp!=='NA') &&<span style={{color:'#707070'}}>{getFormattedDate(x.step3Timestamp)}</span>}

                                                  </div>
                                                  <div className='colorRedOEM' style={{  marginTop: "1rem",marginBottom: "1rem"}} >
                                                    {x.displayMessage}
                                                  </div>
                                                </div>
                                                : <div className="workingText flexSpaceBetween">
                                                <span>
                                                  Processing withdrawal with your{" "}
                                                  {x.withdrawType === "BANK"
                                                    ? "bank"
                                                    : x.withdrawType === "upi"
                                                      ? "bank"
                                                      : "wallet"}
                                                </span>
                                                {(x?.step3Timestamp && x.step3Timestamp!=='NA') &&<span style={{color:'#707070'}}>{getFormattedDate(x.step3Timestamp)}</span>}

                                              </div>
                                            }
                                          </div>

                                          <div
                                            style={{ margin: "3px 3px 3px 0px" }}
                                            className="workingStepRewards"
                                          >
                                            {/* <div className="iconRewards">
                                          <div
                                            // style={{ height: "18px" }}
                                            className="verticalline"
                                          ></div>
                                        </div> */}
                                            <div className="workingText"></div>
                                          </div>

                                          <div className="workingStepRewards">
                                            <div className="iconRewards">
                                              <img
                                                alt="step3Tag"
                                                src={emptyredeem}
                                              ></img>
                                            </div>
                                            <div className="workingText">
                                              <span>
                                                Amount credited to your{" "}
                                                {x.withdrawType === "BANK"
                                                  ? "bank account"
                                                  : x.withdrawType === "upi"
                                                    ? "bank account"
                                                    : "wallet"}
                                              </span>
                                              <div
                                                style={{
                                                  display: "flex",
                                                  alignItems: "flex-end",
                                                  justifyContent: "center",
                                                  float: "right",
                                                  color: "#2C5391",
                                                  fontSize: "0.7rem",
                                                  fontWeight: "700",
                                                  borderBottom:
                                                    "1px solid #2C5391",
                                                }}
                                                onClick={() => {
                                                  WebToNativeMessage({
                                                    type: "openContactUs",
                                                  });
                                                  WebToNativeMessage({
                                                    type: "redeemCTEvent",
                                                    eventName:
                                                      "PF_c_contactus_pageload",
                                                    eventProperties: {
                                                      click_location:
                                                        "Withdraw History",
                                                    },
                                                  });

                                                  WebToNativeMessage({
                                                    type: "redeemCTEvent",
                                                    eventName:
                                                      "PF_c_clickin_RedeemHistoryPage",
                                                    eventProperties: {
                                                      Button_clicked:
                                                        "Need Help?",
                                                      redeem_status:
                                                        x.type ===
                                                          "withdraw-request" ||
                                                          x.type ===
                                                          "withdraw-processing" || x.type === "RA"
                                                          ? "Ongoing"
                                                          : x.type ===
                                                            "withdraw-cancelled"
                                                            ? "Cancelled"
                                                            : (x.type ===
                                                              "Withdraw-success" || x.type === "withdraw")
                                                              && x.step === 4 ? "Completed" : "",
                                                      acelevel:
                                                        window.sessionStorage[
                                                        "aceLevel"
                                                        ],
                                                      channel:
                                                        window.sessionStorage[
                                                        "channel"
                                                        ],
                                                      subscription_type:
                                                        window.sessionStorage[
                                                        "subscriptionType"
                                                        ],
                                                      username:
                                                        window.sessionStorage[
                                                        "screenName"
                                                        ],
                                                      Redeem_Amount: x.amount,
                                                      redeem_mode: x.name,
                                                      Location: 'Redeem History Page',
                                                      RedeemType: x.transactionType,
                                                      isSmartRedeem:x?.isSmartRedeem ? "Yes":"No",
                                                    },
                                                  });
                                                  WebToNativeMessage({
                                                    type: "mixpanelEvent",
                                                    eventName:
                                                      "PF_c_clickin_RedeemHistoryPage",
                                                    eventProperties: {
                                                      Button_clicked:
                                                        "Need Help?",
                                                      redeem_status:
                                                        x.type ===
                                                          "withdraw-request" ||
                                                          x.type ===
                                                          "withdraw-processing" || x.type === "RA"
                                                          ? "Ongoing"
                                                          : x.type ===
                                                            "withdraw-cancelled"
                                                            ? "Cancelled"
                                                            : (x.type ===
                                                              "Withdraw-success" || x.type === "withdraw")
                                                              && x.step === 4 ? "Completed" : "",
                                                      acelevel:
                                                        window.sessionStorage[
                                                        "aceLevel"
                                                        ],
                                                      channel:
                                                        window.sessionStorage[
                                                        "channel"
                                                        ],
                                                      subscription_type:
                                                        window.sessionStorage[
                                                        "subscriptionType"
                                                        ],
                                                      username:
                                                        window.sessionStorage[
                                                        "screenName"
                                                        ],
                                                      Redeem_Amount: x.amount,
                                                      redeem_mode: x.name,
                                                      Location: 'Redeem History Page',
                                                      RedeemType: x.transactionType,
                                                      isSmartRedeem:x?.isSmartRedeem ? "Yes":"No",
                                                    },
                                                  });
                                                }}
                                              >
                                                {" "}
                                                Need help ?
                                              </div>
                                            </div>
                                          </div>
                                        </div>
                                      )}
                                    </div>
                                    {(x.type !== "withdraw" || x.type !== "Withdraw-success" ) && x.type !== "withdraw-cancelled-partial" && <div className="flex items-center justify-center mh2 mv2">
                                      <div
                                        className="flex flex-column items-center br b--gray"
                                        style={{ flex: 1 }}
                                      >
                                        <div className="nowrap fw6 mid-grey f7 mb1">
                                          Redeem
                                        </div>
                                        <div
                                          className="f9 fw7 nowrap primary-blue"
                                          style={{ fontWeight: "700" }}
                                        >
                                          {RUPEE_SYMBOL} {x.amount}
                                        </div>
                                      </div>

                                      {(x.transactionType==='Prime Instant' && x.processingFeeAmount>0) &&  <div
                                      className="flex flex-column items-center br b--gray"
                                      style={{ flex: 1 }}
                                    >
                                      <div className="nowrap fw6 mid-grey f7 mb1">
                                        Fees
                                            <Tooltip
                                              redeemProcessingFee={true}
                                              tooltipArrow="tooltip-arrow"
                                              direction={"bottom"}
                                              content={`${x.processingFeePercent}% of Net withdrawable amount`}
                                            >
                                              <img src={assets?.assets?.InformationBlueIcon} style={{ width: "10px", marginLeft: "3px" }} />
                                            </Tooltip>
                                      </div>
                                      <div
                                        className="f9 fw7 nowrap primary-blue"
                                        style={{ fontWeight: "700" }}
                                      >
                                        {RUPEE_SYMBOL} {x.processingFeeAmount}
                                      </div>
                                    </div> }

                                      <div
                                        className="flex flex-column items-center br b--gray"
                                        style={{ flex: 1 }}
                                      >
                                        <div className="nowrap fw6 mid-grey f7 mb1">
                                          TDS
                                        </div>
                                        <div
                                          className="f9 fw7 nowrap primary-blue"
                                          style={{ fontWeight: "700" }}
                                        >
                                          {RUPEE_SYMBOL} {x.tdsDeducted}
                                        </div>
                                      </div>

                                      <div
                                        className="flex flex-column items-center"
                                        style={{ flex: 1 }}
                                      >
                                        <div
                                        className= "tobecrediteddiv"
                                        >
                                          <div className=" nowrap fw6 ph1 mid-grey f7 mb1 mv1">
                                            To be credited
                                          </div>
                                          <div
                                            className="nowrap f9 fw7 primary-blue"
                                            style={{ fontWeight: "700" }}
                                          >
                                            {RUPEE_SYMBOL}{" "}
                                            {x.amountToBeCredited}
                                          </div>
                                        </div>
                                      </div>
                                    </div>}
                                  </div>)
                                }

                                {(x.type !== "withdraw-cancelled" && x.type !== "withdraw-cancelled-partial") && (
                                  <div className="flex items-center justify-center mh2 mv2">
                                    <div
                                      className="flex flex-column items-center br b--gray"
                                      style={{ flex: 1 }}
                                    >
                                      <div className=" nowrap contoBold mid-grey f7 mb1">
                                        Redeem
                                      </div>
                                      <div className="f9 nowrap fw7 primary-blue">
                                        {RUPEE_SYMBOL} {x.amount}
                                      </div>
                                    </div>

                                    {
                                    x.isPartiallyCancelled && <div
                                      className="flex flex-column items-center br b--gray"
                                      style={{ flex: 1 }}
                                    >
                                      <div className="nowrap fw6 mid-grey f7 mb1">
                                        Cancellation
                                      </div>
                                      <div
                                        className="f9 fw7 nowrap primary-blue"
                                        style={{ fontWeight: "700" }}
                                      >
                                        {RUPEE_SYMBOL} {x.totalPartialCancellationAmt}
                                      </div>
                                    </div>
                                    }
                                    {(x.transactionType==='Prime Instant' && x.processingFeeAmount>0) &&  <div
                                      className="flex flex-column items-center br b--gray"
                                      style={{ flex: 1 }}
                                    >
                                      <div className="nowrap fw6 mid-grey f7 mb1">
                                        Fees
                                        <Tooltip
                                            redeemProcessingFee={true}
                                            tooltipArrow="tooltip-arrow"
                                            direction={"bottom"}
                                            content={`${x.processingFeePercent}% of Net withdrawable amount`}
                                          >
                                            <img src={assets?.assets?.InformationBlueIcon} style={{ width: "10px", marginLeft: "3px" }} />
                                          </Tooltip>
                                      </div>
                                      <div
                                        className="f9 fw7 nowrap primary-blue"
                                        style={{ fontWeight: "700" }}
                                      >
                                        {RUPEE_SYMBOL} {x.processingFeeAmount}
                                      </div>
                                    </div> }
                                    <div
                                      className="flex flex-column items-center br b--gray"
                                      style={{ flex: 1 }}
                                    >
                                      <div className="nowrap contoBold mid-grey f7 mb1">
                                        TDS
                                      </div>
                                      <div className="f9 fw7 nowrap primary-blue">
                                        {RUPEE_SYMBOL} {x.tdsDeducted}
                                      </div>
                                    </div>

                                    <div
                                      className="flex flex-column items-center"
                                      style={{ flex: 1 }}
                                    >
                                      <div
                                        className="flex flex-column items-center"
                                        style={{ background: "#196A291F" }}
                                      >
                                        <div className="f7 nowrap contoBold mid-grey mv1 pt1 pb1 ph2">
                                          Credited
                                        </div>
                                        <div className="nowrap f9 fw7 primary-blue pb1 ph2">
                                          {RUPEE_SYMBOL}{" "}
                                          {x.amountToBeCredited}
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                )}

                                { x.transactionType === "instant" && !x.autoCheckStatus && <div style={{width:"100%",background:'#f2f2f2',fontSize:"0.7rem",color:"#032146",padding:"8px 5px",boxSizing:"border-box",fontWeight:"600",borderRadius:"6px",marginTop:"10px"}}>Note - Unfortunately, this Instant withdrawal will be considered as Standard due to additional checks.</div>}
                                {x.transactionType === 'Prime Instant' && x.cancelNoteMsg!=='' && <div style={{width:"100%",background:'#f2f2f2',fontSize:"0.7rem",color:"#032146",padding:"8px 5px",boxSizing:"border-box",fontWeight:"600",borderRadius:"6px",marginTop:"10px"}}>Note - {x.cancelNoteMsg}</div>}
                               {/* OEM USER */}
                                { sessionStorage && sessionStorage.getItem("channel").toLowerCase() !== "oemaps1" && x.type !== "withdraw-cancelled" &&
                                  x.showFeedbackFlag !== false && (
                                    <div
                                      key={x._id}
                                      className="w-100"
                                      style={{
                                        display: "flex",
                                        alignItems: "center",
                                        justifyContent: "center",
                                        paddingTop: "3%",
                                        marginTop: "3%",
                                        borderTop: "1px solid #bababa",
                                      }}
                                    >
                                      {
                                        <div className="flex justify-between w-100">
                                          {
                                            <div
                                              key={index}
                                              className={`flex items-center contoBold mid-grey f8 nowrap  ${!feedbackResponse
                                                  ? "w-60"
                                                  : "w-100"
                                                } `}
                                            >
                                              {/* {feedbackM} */}
                                              {!feedbackM ? (
                                                "How was your experience ? "
                                              ) : activeFeedback === index ? (
                                                <div className="flex w-100 justify-between">
                                                  <div
                                                    className=" flex mid-grey "
                                                    style={{
                                                      fontSize: "0.65rem",
                                                      width: "80%",
                                                      alignItems: "self-end",
                                                    }}
                                                  >
                                                    Great! Refer your friends
                                                    now and earn more.{" "}
                                                  </div>
                                                  <div
                                                    className="flex"
                                                    style={{ width: "20%" }}
                                                  >
                                                    <div
                                                      style={{
                                                        display: "flex",
                                                        alignItems: "center",
                                                        justifyContent:
                                                          "center",
                                                        float: "right",
                                                        color: "#2C5391",
                                                        fontSize: "0.7rem",
                                                        fontWeight: "700",
                                                        borderBottom:
                                                          "1px solid #2C5391",
                                                      }}
                                                      onClick={() => {
                                                        WebToNativeMessage({
                                                          type: "openR&E",
                                                          token:
                                                            window
                                                              .sessionStorage[
                                                            "token"
                                                            ],
                                                        });
                                                        WebToNativeMessage({
                                                          type: "redeemCTEvent",
                                                          eventName:
                                                            "PF_c_RedeemFeedback_ClickReferNow",
                                                          eventProperties: {
                                                            acelevel:
                                                              window
                                                                .sessionStorage[
                                                              "aceLevel"
                                                              ],
                                                            channel:
                                                              window
                                                                .sessionStorage[
                                                              "channel"
                                                              ],
                                                            subscription_type:
                                                              window
                                                                .sessionStorage[
                                                              "subscriptionType"
                                                              ],
                                                            username:
                                                              window
                                                                .sessionStorage[
                                                              "screenName"
                                                              ],
                                                            Redeem_Amount:
                                                              x.amount,
                                                            redeem_mode: x.name,
                                                          },
                                                        });
                                                      }}
                                                    >
                                                      Refer Now
                                                    </div>
                                                  </div>
                                                </div>
                                              ) : (
                                                <div className="flex justify-between w-100">
                                                  <div className="flex items-center contoBold mid-grey f8 nowrap w-60">
                                                    How was your experience ?
                                                  </div>
                                                  <div
                                                    className="flex flex-row w-40 items-center"
                                                    style={{
                                                      justifyContent:
                                                        "flex-end",
                                                    }}
                                                  >
                                                    <div
                                                      className="mr3"
                                                      onClick={() => {
                                                        handleLikeClick(
                                                          x._id,
                                                          x.amount,
                                                          x.name
                                                        );
                                                        feedbackToggle(index);
                                                      }}
                                                    >
                                                      <div
                                                        style={{
                                                          display: "flex",
                                                          color: "green",
                                                          borderBottom:
                                                            "1px solid green",
                                                        }}
                                                      >
                                                        <img
                                                          style={{
                                                            width: "1rem",
                                                            marginBottom:
                                                              "0.1rem",
                                                          }}
                                                          alt="like"
                                                          src={like}
                                                        />{" "}
                                                        <div
                                                          className="flex ml1 f8"
                                                          style={{
                                                            marginBottom:
                                                              "0.1rem",
                                                          }}
                                                        >
                                                          {" "}
                                                          Good
                                                        </div>
                                                      </div>
                                                    </div>
                                                    <div
                                                      className=""
                                                      onClick={() => {
                                                        handleDislikeClick(
                                                          x._id,
                                                          x.amount,
                                                          x.name
                                                        );
                                                      }}
                                                    >
                                                      <div
                                                        style={{
                                                          display: "flex",
                                                          color: "#C62828",
                                                          borderBottom:
                                                            "1px solid #C62828",
                                                        }}
                                                      >
                                                        <img
                                                          style={{
                                                            width: "1rem",
                                                            marginBottom:
                                                              "0.1rem",
                                                          }}
                                                          alt="dislike"
                                                          src={dislike}
                                                        />{" "}
                                                        <div
                                                          className="flex ml1 f8"
                                                          style={{
                                                            marginBottom:
                                                              "0.1rem",
                                                          }}
                                                        >
                                                          {" "}
                                                          Bad
                                                        </div>
                                                      </div>
                                                    </div>
                                                  </div>
                                                </div>
                                              )}
                                            </div>
                                          }
                                          {!feedbackResponse && (
                                            <div
                                              className="flex flex-row w-40 items-center"
                                              style={{
                                                justifyContent: "flex-end",
                                              }}
                                            >
                                              <div
                                                className="mr3"
                                                onClick={() => {
                                                  handleLikeClick(
                                                    x._id,
                                                    x.amount,
                                                    x.name
                                                  );
                                                  feedbackToggle(index);
                                                }}
                                              >
                                                <div
                                                  style={{
                                                    display: "flex",
                                                    color: "green",
                                                    borderBottom:
                                                      "1px solid green",
                                                  }}
                                                >
                                                  <img
                                                    style={{
                                                      width: "1rem",
                                                      marginBottom: "0.1rem",
                                                    }}
                                                    alt="like"
                                                    src={like}
                                                  />{" "}
                                                  <div
                                                    className="flex ml1 f8"
                                                    style={{
                                                      marginBottom: "0.1rem",
                                                    }}
                                                  >
                                                    {" "}
                                                    Good
                                                  </div>
                                                </div>
                                              </div>
                                              <div
                                                className=""
                                                onClick={() => {
                                                  handleDislikeClick(
                                                    x._id,
                                                    x.amount,
                                                    x.name
                                                  );
                                                }}
                                              >
                                                <div
                                                  style={{
                                                    display: "flex",
                                                    color: "#C62828",
                                                    borderBottom:
                                                      "1px solid #C62828",
                                                  }}
                                                >
                                                  <img
                                                    style={{
                                                      width: "1rem",
                                                      marginBottom: "0.1rem",
                                                    }}
                                                    alt="dislike"
                                                    src={dislike}
                                                  />{" "}
                                                  <div
                                                    className="flex ml1 f8"
                                                    style={{
                                                      marginBottom: "0.1rem",
                                                    }}
                                                  >
                                                    {" "}
                                                    Bad
                                                  </div>
                                                </div>
                                              </div>
                                            </div>
                                          )}
                                        </div>
                                      }{" "}
                                    </div>
                                  )}
                              </div>
                            </div>
                          )}
                        </div>
                      </div>
                    </div>
                  );
                }
              })}

            {showMoreRequests &&
              <div className="flex w-100 items-center justify-center mb2 mt1" style={{ position: "absolute", height: "5%" }}>
                <div
                  className="olderRedeemsDiv"
                  id="show_older_redeems"
                  onClick={() => {
                    getMoreHistoryData();
                    WebToNativeMessage({
                      type: "redeemCTEvent",
                      eventName:
                        "PF_c_clickin_RedeemHistoryPage",
                      eventProperties: {
                        Button_clicked: "Show older requests",
                        redeem_status: "Nil",
                        acelevel:
                          window.sessionStorage["aceLevel"],
                        channel:
                          window.sessionStorage["channel"],
                        subscription_type:
                          window.sessionStorage[
                          "subscriptionType"
                          ],
                        username:
                          window.sessionStorage[
                          "screenName"
                          ],
                        Redeem_Amount: "",
                        redeem_mode: "Nil",
                        Location: 'Redeem History Page',
                        RedeemType: 'NA',
                        isSmartRedeem:"No",
                        
                      },
                    });
                    WebToNativeMessage({
                      type: "mixpanelEvent",
                      eventName:
                        "PF_c_clickin_RedeemHistoryPage",
                      eventProperties: {
                        Button_clicked: "Show older requests",
                        redeem_status: "Nil",
                        acelevel:
                          window.sessionStorage["aceLevel"],
                        channel:
                          window.sessionStorage["channel"],
                        subscription_type:
                          window.sessionStorage[
                          "subscriptionType"
                          ],
                        username:
                          window.sessionStorage[
                          "screenName"
                          ],
                        Redeem_Amount: "",
                        redeem_mode: "Nil",
                        Location: 'Redeem History Page',
                        RedeemType: 'NA',
                        isSmartRedeem:"No",
                        
                      },
                    });

                  }}
                >
                  <span>Show Older Withdraws</span>
                </div>
              </div>
            }

            {!showMoreRequests && redeemhistory.newUser !== undefined && !redeemhistory.newUser &&
              <div>
                {completedRequests !== undefined && completedRequests.length === 0 ? (
                  <div
                    className="flex items-left flex-column"
                    style={{ marginLeft: "5%" }}
                  >
                    <div className=" tl mv2 mid-grey fw6">
                      No withdraw requests in the last 30 days
                    </div>
                    <div className=" tl mv2 mid-grey">
                      Contact customer support in case you need more information
                    </div>
                  </div>
                ) : (
                  <div
                    className=" tl mv3 mid-grey ph2"
                    style={{ marginLeft: "5%" }}
                  >
                    Contact customer support in case you need more information
                    about withdraw requests beyond last 30 days.
                  </div>
                )}
                <div
                  style={{
                    width: "90%",
                    height: "2.5rem",
                    marginBottom: "5%",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    marginLeft: "5%",
                  }}
                >
                  <div
                    style={{
                      width: "100%",
                      height: "95%",
                      border: "1px solid #2C5391",
                      borderRadius: "4px",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      color: "#2C5391",
                      fontWeight: "700",
                    }}
                    onClick={() => {
                      WebToNativeMessage({ type: "openContactUs" });
                      WebToNativeMessage({
                        type: "redeemCTEvent",
                        eventName: "PF_c_contactus_pageload",
                        eventProperties: { click_location: "Redeem History" },
                      });
                    }}
                  >
                    <img
                      src={callUsIcon}
                      alt="contactUs"
                      style={{ height: "35%", marginRight: "2%" }}
                    />{" "}
                    <span>Contact Us</span>
                  </div>
                </div>
              </div>
            }
          </div>
        </div>
        {showPopup && redeemDetails !== undefined && redeemDetails.feedbackPopupBody !== undefined && redeemDetails.feedbackPopupOptions !== undefined && redeemDetails.feedbackPopupTitle !== undefined &&
          createFeedBackPopUp()}
        {!feedbackResponse &&
          toastMessageFeedback !== undefined &&
          !toastInvisible &&
          createToastMessage()}
      </div>
    </div>
  );
};

const mapStateToProps = (state) => ({
  userState: state.userState,
  networkStatus: state.userState.networkStatus,
});

export default connect(mapStateToProps, {
  toggleModalAction,
  getRedeemHistoryAction,
  getCancleWithdrawAction,
  toggleAlertAction,
})(RedeemHistoryTwo);


